export default {
  // Ferry specific
  "no_ferry_stops_nearby": "Ingen fergekaier i nærheten",
  "no_ferry_within_range": "Det finnes ingen fergekaier innenfor {km} km fra din posisjon",
  "no_ferry_docks_found": "Kunne ikke finne fergekaier",
  "ferry_dock_found": "Fergekai funnet",
  "away": "unna",
  "showing_nearest_stop": "Viser nærmeste stoppested i stedet",
  "loading_ferry_stops": "Laster fergekaier...",
  "nearest_ferry_dock": "Nærmeste fergekai",
  "nearest_ferry_route": "Nærmeste samband",
  "next_departures": "Neste avganger",
  "from_nearest_dock": "Fra nærmeste kai",
  "return_label": "Retur",
  "no_upcoming_departures": "Ingen kommende avganger",
  "no_upcoming_departures_found": "Ingen kommende avganger funnet",
  "ferry_connection_label": "Samband: {from} – {to}",
  "add_to_calendar": "Legg til i kalender",
  "add_to_calendar_departure_aria": "Legg til avgang {time} til {destination} i kalender",
  "remove_favorite": "Fjern favoritt",
  "add_favorite": "Legg til som favoritt",
  "remove_favorite_aria": "Fjern {name} fra favoritter",
  "add_favorite_aria": "Legg til {name} som favoritt",
  "show_camera": "Vis kamera",
  "hide_camera": "Skjul kamera",
  "ferry_link_copied_description": "Fergelenken er kopiert til utklippstavlen",
  "webcam_alt": "Webkamera: {name}",
  "camera_image_unavailable": "Kamerabildet er midlertidig utilgjengelig",
  "no_camera_for_dock": "Ingen kamera tilgjengelig for dette fergeleiet",
  // Quick Access
  "quick_access": "Hurtigvalg",
  "quick_access_empty": "Favoritter og nylige søk vises her for rask tilgang",
  "favorites": "Favoritter",
  "swap_fields": "Bytt fra/til",
  "history_expires_warning": "Søkehistorikken nullstilles etter 48 timer.",
  "login_to_save": "Logg inn for å lagre permanent",
  // Header
  "menu": "Meny",
  "home": "Hjem",
  "guide": "Veiledning",
  "about": "Om oss",
  "contact": "Kontakt",
  "help": "Hjelp & FAQ",
  "legal": "Juridisk",
  "privacy": "Personvern",
  "cookies": "Cookies",
  "cookie_settings": "Cookie-innstillinger",
  "footer_tagline": "Raskeste vei MED ferge",
  "footer_about_heading": "Om Ruty",
  "footer_legal_heading": "Juridisk",
  "terms": "Vilkår",
  "open_menu": "Åpne meny",
  "title": "Ruty - kollektivtrafikk stoppesteder",
  "homepage_title": "Ruty – Ferger og kollektivtransport i Norge",
  "homepage_description": "Norges beste app for fergeruter og kollektivtransport. Live avgangstider, nærmeste samband og ruteplanlegger.",
  "kollektiv_seo_title": "Kollektivtransport Norge – Live avganger | Ruty",
  "kollektiv_seo_description": "Finn nærmeste busser, tog og stopp med live avganger. Ruteplanlegger for kollektivtransport i Norge.",
  "kollektiv_hero_title": "Planlegg reisen din",
  "kollektiv_hero_subtitle": "Søk blant alle buss, tog, trikk, T-bane og fergeruter i Norge",
  
  // Footer
  "data_from": "Data fra Entur og Avinor",
  
// Main page
  "destination_placeholder": "Skriv inn destinasjon for å få ruteforslag",
  "new_search": "Nytt søk",
  "plan_trip": "planlegg reise",
  "plan_your_trip": "Planlegg din reise",
  "plan_smarter": "Planlegg reise smartere",
  "from": "Fra",
  "to": "Til",
  "from_placeholder": "Skriv inn avreisested",
  "to_placeholder": "Skriv inn destinasjon",
  "my_position": "Min posisjon",
  "search_trips": "Søk reiser",
  "fill_both_fields": "Fyll ut begge felt",
  "enter_from_and_to": "Skriv inn både avreisested og destinasjon",
  "origin_not_found": "Fant ikke avreisestedet",
  "try_another_origin": "Prøv et annet avreisested",
  "searching_trips": "Søker etter reiser...",
  "geolocation_not_supported": "Geolokalisering støttes ikke",
  "browser_no_geolocation": "Nettleseren din støtter ikke geolokalisering",
  "could_not_get_position": "Kunne ikke finne posisjon",
  "grant_location_access": "Vennligst gi tilgang til posisjon for å søke etter reiser",
  "position_found": "Posisjon funnet",
  "position_found_desc": "Din posisjon er lagt til i fra-feltet",
  "location_permission_denied": "Du må gi tilgang til posisjon i nettleseren",
  "location_unavailable": "Posisjonstjenesten er utilgjengelig",
  "location_timeout": "Tidsavbrudd ved henting av posisjon",
  "outside_norway": "Utenfor Norge",
  "outside_norway_desc": "Du ser ut til å være utenfor Norge. Skriv inn ønsket avreisested manuelt.",
  "nearby_routes": "Ruter i nærheten:",
  "loading_suggestions": "Laster forslag...",
  "loading_departures": "Laster avganger...",
  "no_trips_available": "Ingen tilgjengelige reiser til {destination} akkurat nå",
  "next_departure_passed": "Neste avgang har allerede passert. Prøv igjen senere.",
  "no_trips_found": "Ingen reiser funnet til {destination}",
  "try_another_destination": "Prøv en annen destinasjon",
  "distance_too_far": "Avstanden er for lang for effektivt rutesøk",
  "plan_shorter_stages": "Vennligst planlegg reisen i kortere etapper",
  "error": "Feil",
  "could_not_fetch_stops": "Kunne ikke hente stoppesteder",
  "no_stops_nearby": "Ingen stoppesteder funnet i nærheten",
  "try_again_elsewhere": "Prøv igjen et annet sted eller senere",
  
  // LocationButton
  "geolocation_not_supported_browser": "Geolokalisering støttes ikke av nettleseren din",
  "could_not_get_location": "Kunne ikke finne din posisjon. Vennligst gi tilgang til posisjon.",
  "loading_stops": "Laster stoppesteder...",
  "find_nearest_stop": "Finn nærmeste stoppested",
  
  // StopCard
  "bus": "Buss",
  "ferry": "Ferge",
  "rail": "Tog",
  "tram": "Trikk",
  "flight": "Fly",
  "departed": "Avgått",
  "now": "Nå",
  "tomorrow": "I morgen",
  "in_days": "Om {days} dager",
  "next_departures_from": "Neste avganger fra",
  "min_walk": "{minutes} min gange",
  "search_destination": "Finn stopp på ruten eller nytt reisemål",
  "search_routes_to": "Søk etter ruter til",
  "no_departures_found": "Ingen avganger funnet",
  "no_departures_to": "Ingen avganger til \"{destination}\" som du kan rekke",
  "no_departures_can_catch": "Ingen avganger du kan rekke (gangtid: {minutes} min)",
  "try_closer_stop": "💡 Prøv å søke etter et nærmere stoppested",
  "towards": "mot",
  "departures_you_can_catch": "{count} avganger du kan rekke",
  "show_all_departures": "Vis alle {count} avganger",
  "show_less": "Vis færre",
  "tip_search_destination": "Skriv inn en destinasjon i søkefeltet over for å få komplette reiseforslag fra dette stoppet.",
  
  // Approaching Vehicles
  "approaching_vehicles": "Kommende avganger",
  "approaching_buses": "Kommende busser",
  "realtime_last_updated": "Oppdatert",
  "waiting_for_realtime": "Venter på sanntidsdata...",
  "no_realtime_data": "Sanntidsposisjon ikke tilgjengelig ennå",
  "track_vehicle": "Følg denne bussen",
  "stop_tracking": "Slutt å følge",
  "tracking_vehicle": "Følger",
  "following": "Følger",
  
  // TripPlan
  "trips_to": "Reiser til",
  "alternative": "Alternativ",
  "metro": "T-bane",
  "taxi": "Taxi",
  "overnight": "Overnatting",
  "walk": "Gå",
  "no_public_transport": "💡 Ingen kollektivtransport funnet - taxi anbefales",
  "overnight_needed": "Overnatting nødvendig på flyplass eller i nærheten",
  "first_transport_evening": "Første kollektivtransport går kvelden før flyavgang",
  "flight_time": "Flytid",
  "gate": "Gate",
  "status": "Status",
  "status_new_time": "Ny tid",
  "status_cancelled": "Kansellert",
  "status_departed": "Avgått",
  "switch": "Bytte",
  "total_walk_distance": "Total gangavstand",
  "departures_to": "Avganger til",
  "updating": "Oppdaterer…",
  "recommended_badge": "ANBEFALT",
  "deviation": "Avvik",
  "walk_meters": "Gå {meters} meter",
  
  // FeedbackForm
  "give_feedback": "Gi tilbakemelding",
  "choose_feedback_type": "Velg type tilbakemelding",
  "positive": "Positiv",
  "negative": "Negativ",
  "suggestion": "Forslag",
  "bug": "Feilrapport",
  "your_feedback": "Din tilbakemelding",
  "optional": "(valgfritt)",
  "tell_us_experience": "Fortell oss om din opplevelse...",
  "comment_min_length": "Kommentar må være minst 10 tegn for forslag og feilrapporter",
  "comment_max_length": "Kommentar kan ikke være mer enn 1000 tegn",
  "characters": "tegn",
  "sending": "Sender...",
  "send_feedback": "Send tilbakemelding",
  "thanks_feedback": "Takk for tilbakemeldingen!",
  "feedback_helps": "Din tilbakemelding hjelper oss å forbedre tjenesten.",
  "something_wrong": "Noe gikk galt",
  "could_not_send_feedback": "Kunne ikke sende tilbakemelding. Vennligst prøv igjen senere.",
  
  // SearchHistory
  "recent_searches": "Nylige søk",
  "favorite_trips": "Favorittreiser",
  "your_favorite_trips": "Dine favorittreiser",
  "favorite_trips_empty": "Reiser du markerer med ♥ vises her for rask tilgang",
  "no_favorite_trips": "Du har ingen favorittreiser ennå. Marker en reise med hjertet for å lagre den her.",
  "search_history": "Søkehistorikk",
  "your_recent_searches": "Dine nylige søk",
  "no_search_history": "Ingen søkehistorikk ennå",
  "clear_all": "Slett alle",
  
  // PopularRoutes
  "popular_destinations": "Populære destinasjoner",
  "popular_routes": "Populære ruter",
  "popular_in_area": "Populært i ditt område",
  "loading": "Laster...",
  "searches": "søk",
  "click_destination_search": "Klikk på en destinasjon for å søke etter reiser",
  "click_route_search": "Klikk på en rute for å søke etter reiser",
  "live_updates": "Sanntid",
  "trend_rising": "Stiger",
  "trend_steady": "Stabil",
  "trend_falling": "Synker",
  
  // NewsletterSignup
  "newsletter_heading": "Nyhetsbrev",
  "newsletter_description": "Få oppdateringer om nye funksjoner og nyheter",
  "newsletter_email_placeholder": "din@epost.no",
  "newsletter_submit": "Meld på",
  "newsletter_submitting": "Melder på...",
  "newsletter_already_subscribed_title": "Du er allerede påmeldt!",
  "newsletter_already_subscribed_body": "Denne e-postadressen er allerede registrert i vårt nyhetsbrev.",
  "newsletter_welcome_title": "Velkommen!",
  "newsletter_welcome_body": "Du er nå påmeldt vårt nyhetsbrev.",
  "newsletter_error_title": "Noe gikk galt",
  "newsletter_error_body": "Kunne ikke melde deg på. Prøv igjen senere.",
  "newsletter_invalid_email": "Ugyldig e-postadresse",
  "newsletter_email_too_long": "E-postadressen er for lang",
  
  // ShareButtons
  "share_service": "Del Ruty",
  "shared": "Delt!",
  "thanks_sharing": "Takk for at du deler Ruty",
  "link_copied": "Lenke kopiert!",
  "link_copied_clipboard": "Lenken er kopiert til utklippstavlen",
  "could_not_copy": "Kunne ikke kopiere lenke",
  "try_share_buttons": "Prøv igjen eller bruk en av delingsknappene",
  "share": "Del",
  "share_facebook_aria": "Del på Facebook",
  "share_twitter_aria": "Del på Twitter",
  "share_linkedin_aria": "Del på LinkedIn",
  "share_whatsapp_aria": "Del på WhatsApp",
  "share_email_aria": "Del via e-post",
  "share_email_label": "E-post",
  "share_default_title": "Ruty - Finn nærmeste transport i Norge",
  "share_default_description": "Finn nærmeste kollektivtransport med sanntidsavganger i hele Norge. Buss, tog, ferge og fly - helt gratis.",
  
  // NotFound
  "page_not_found": "Siden finnes ikke",
  "oops_not_found": "Oops! Siden du leter etter finnes ikke.",
  "return_home": "Gå til startsiden",
  
  // Guide page
  "guide_title": "Veiledning til Ruty",
  "guide_subtitle": "Alt du trenger å vite for å bruke Ruty effektivt og spare tid på reiseplanlegging.",
  "guide_seo_description": "Veiledning til Ruty: nærmeste ferge, sanntid, tips – og hvordan AutoPASS fungerer på norske bilferger.",
  "guide_quick_tips_title": "Hurtigtips",
  "guide_autopass_title": "AutoPASS på ferge",
  "guide_autopass_intro": "Mange norske bilferger betales med AutoPASS-brikke, ferjekort eller kort ved kai. Her er det viktigste før du kjører til sambandet.",
  "guide_autopass_what_title": "Hva er AutoPASS på ferge?",
  "guide_autopass_what_body": "AutoPASS er Norges system for automatisk betaling på bom og mange ferjesamband. Med brikke eller ferjeavtale trekkes betalingen ofte automatisk når du kjører om bord – uten å kjøpe billett i en egen app først.",
  "guide_autopass_ruty_note": "Ruty viser avganger og samband – ikke billettkjøp. Betalingsregler følger rederiet og sambandet. Sjekk sambandsiden i Ruty og rederiets info før du kjører til kai.",
  "guide_autopass_tips_title": "Tips før du kjører til ferjekai",
  "guide_autopass_tip_1": "Sjekk om sambandet bruker AutoPASS, ferjekort eller manuell betaling om bord.",
  "guide_autopass_tip_2": "Kom tidlig i rushtid – kø og kapasitet avgjør ofte mer enn betalingsmåten.",
  "guide_autopass_tip_3": "Har du ikke brikke: mange samband tar kort eller har egen løsning – se rederiets info.",
  "guide_autopass_tip_4": "Åpne sambandet i Ruty for neste avgang, så planlegger du betaling og ankomst sammen.",
  "guide_autopass_faq_heading": "Vanlige spørsmål om AutoPASS og ferge",
  "guide_autopass_faq_q1": "Må jeg ha AutoPASS-brikke for å ta bilferge?",
  "guide_autopass_faq_a1": "Ikke alltid. Mange samband støtter AutoPASS, men alternativer som kort eller ferjekort finnes ofte. Reglene varierer per samband og rederi.",
  "guide_autopass_faq_q2": "Kan jeg betale AutoPASS via Ruty?",
  "guide_autopass_faq_a2": "Nei. Ruty er for avganger og planlegging. Betaling går via AutoPASS, rederiet eller om bord – ikke gjennom Ruty.",
  "guide_autopass_faq_q3": "Hvor finner jeg mer om AutoPASS-ferje?",
  "guide_autopass_faq_a3": "Se offisiell info på autopass.no, og sjekk sambandsiden i Ruty for det konkrete sambandet du skal ta.",
  "guide_autopass_official_link": "Offisiell AutoPASS-info (autopass.no)",
  "quick_search": "Raskt søk",
  "quick_search_desc": "Finn transport på sekunder",
  "realtime_data": "Sanntidsdata",
  "realtime_data_desc": "Alltid oppdatert informasjon",
  "smart_routing": "Smart ruteplanlegging",
  "smart_routing_desc": "Finn beste rute",
  "mobile_friendly": "Mobilvennlig",
  "mobile_friendly_desc": "Fungerer overalt",
  
  // Guide page - detailed content
  "quick_search_detail": "Klikk på posisjonsknappen og få umiddelbar tilgang til nærmeste stoppesteder og avganger. Ingen registrering eller pålogging nødvendig.",
  "realtime_data_detail": "All informasjon kommer direkte fra Entur og Avinor i sanntid. Forsinkelser og kanselleringer vises automatisk.",
  "smart_routing_detail": "Skriv inn destinasjon for å få forslag til komplette reiseruter med bytter, gangtid og totaltid.",
  "mobile_friendly_detail": "Optimalisert for mobil, nettbrett og desktop. Ingen app-nedlasting nødvendig - bare åpne i nettleser.",
  
  "step_by_step_guide": "Steg-for-steg veiledning",
  "step_1_title": "Finn nærmeste stoppested",
  "step_1_desc": "Start her for å se avganger i nærheten",
  "step_1_text_1": "Åpne ruty.no i nettleseren din",
  "step_1_text_2": "Klikk på den store knappen \"Finn min posisjon\"",
  "step_1_text_3": "Godta at nettleseren får tilgang til din posisjon",
  "step_1_text_4": "Se nærmeste stoppested med alle avganger",
  
  "step_2_title": "Planlegg en reise",
  "step_2_desc": "Få ruteforslag til din destinasjon",
  "step_2_text_1": "Skriv inn destinasjonen i søkefeltet (f.eks. \"Oslo S\", \"Fredrikstad\", \"Gardermoen\")",
  "step_2_text_2": "Klikk \"Finn min posisjon\"",
  "step_2_text_3": "Se flere ruteforslag sortert etter reisetid",
  "step_2_text_4": "Velg ruten som passer deg best",
  
  "step_3_title": "Forstå informasjonen",
  "step_3_desc": "Viktige symboler og informasjon",
  "info_walk_time": "Gangtid:",
  "info_walk_time_desc": "Estimert tid å gå til stoppestedet fra din posisjon",
  "info_distance": "Avstand:",
  "info_distance_desc": "Luftlinjedistanse til stoppestedet",
  "info_line": "Linje:",
  "info_line_desc": "Buss-, tog- eller fergenummer",
  "info_destination": "Destinasjon:",
  "info_destination_desc": "Hvor transporten skal",
  "info_time": "Tid:",
  "info_time_desc": "Sanntidsavgang (oppdateres kontinuerlig)",
  
  "tips_tricks_title": "Tips & Triks",
  "time_saving_tips": "Tidsbesparende tips",
  "time_saving_tip_1": "Bokmerk siden: Legg til ruty.no som bokmerke for rask tilgang",
  "time_saving_tip_2": "Legg til på hjemskjerm: På mobil kan du legge til siden på hjemskjermen som en app",
  "time_saving_tip_3": "Søk før du går: Sjekk avganger hjemmefra før du går til stoppestedet",
  "time_saving_tip_4": "Buffertid: Legg alltid til 2-3 minutter ekstra for å rekke avgangen",
  
  "travel_planning": "Reiseplanlegging",
  "travel_planning_tip_1": "Sammenlign alternativer: Se flere ruteforslag og velg det beste",
  "travel_planning_tip_2": "Sjekk gangavstand: Noen bytter kan kreve mye gange",
  "travel_planning_tip_3": "Værforhold: Ta hensyn til vær og veiforhold når du beregner gangtid",
  "travel_planning_tip_4": "Rushtid: Legg til ekstra tid i rushtidsperioder (07:00-09:00, 15:00-17:00)",
  
  "mobile_usage": "Mobilbruk",
  "mobile_usage_tip_1": "Aktiver GPS: Sørg for at GPS/posisjonstjenester er på",
  "mobile_usage_tip_2": "God dekning: Fungerer best med god mobildekning",
  "mobile_usage_tip_3": "Batteribruk: Bruk av GPS kan drenere batteriet - ha lader tilgjengelig",
  "mobile_usage_tip_4": "Offline: Last siden mens du har internett, men data må oppdateres med internett",
  
  "optimal_use_cases": "Optimale bruksområder",
  "optimal_use_case_1": "Ukjente områder hvor du ikke vet hvor stoppestedene er",
  "optimal_use_case_2": "Når du skal til et nytt sted og trenger ruteforslag",
  "optimal_use_case_3": "For å sjekke om du kan rekke avgangen før du løper",
  "optimal_use_case_4": "Sammenligne flere transportalternativer raskt",
  
  "troubleshooting_title": "Feilsøking",
  "troubleshooting_desc": "Vanlige problemer og løsninger",
  "position_not_showing": "Posisjon vises ikke",
  "position_solution_1": "Løsning 1: Sjekk at nettleseren har tillatelse til posisjon",
  "position_solution_2": "Løsning 2: Aktiver GPS/posisjonstjenester på enheten",
  "position_solution_3": "Løsning 3: Gå ut for bedre GPS-signal",
  "position_solution_4": "Løsning 4: Prøv en annen nettleser",
  
  "no_stops_nearby_title": "Ingen stoppesteder i nærheten",
  "no_stops_reason": "Årsak: Du er kanskje utenfor dekningsområdet for kollektivtransport",
  "no_stops_solution": "Løsning: Prøv å søke etter nærmeste tettsted eller by i søkefeltet",
  
  "wrong_departure_times": "Feil avgangstider",
  "wrong_times_explanation": "Forklaring: Data kommer fra Entur/transportselskaper og kan ha forsinkelser i oppdateringen",
  "wrong_times_solution": "Løsning: Dobbeltsjekk med transportselskapet eller Entur-appen for viktige reiser",
  
  "pro_tips_title": "Pro tips fra erfarne brukere",
  "pro_tips_desc": "Best practice for effektiv bruk",
  "pro_tip_1": "Sjekk avganger 5-10 minutter før du går hjemmefra",
  "pro_tip_2": "Bruk ruteplanleggeren for ukjente destinasjoner",
  "pro_tip_3": "Ha alltid 5 minutters buffer ved bytter",
  "pro_tip_4": "Lagre siden som bokmerke eller på hjemskjermen",
  "pro_tip_5": "Kombiner med Entur-appen for billettkjøp",
  "pro_tip_6": "Sjekk værmelding når du planlegger reisen",
  
  "useful_links_title": "Nyttige lenker",
  "link_help": "→ Hjelp & FAQ - Svar på vanlige spørsmål",
  "link_contact": "→ Kontakt oss - Send tilbakemelding eller spørsmål",
  "link_entur": "→ Entur.no - Kjøp billetter og mer informasjon",
  "link_avinor": "→ Avinor.no - Flyinformasjon",
  
  "ready_to_travel": "Klar til å reise?",
  "try_kollektivstopp_now": "Prøv Ruty nå og opplev hvor enkelt det er å finne transport!",
  "find_my_position": "Finn min posisjon",
  
  // About page
  "about_title": "Om Ruty",
  "about_subtitle": "Vi gjør kollektivtransport i Norge enklere og mer tilgjengelig med sanntidsdata fra Entur og Avinor.",
  "our_vision": "Vår visjon",
  "our_vision_desc": "Enklere hverdagsreiser for alle",
  "vision_text": "Ruty er laget for å gjøre kollektivtransport i Norge enklere og mer tilgjengelig. Vi tror at god tilgang til sanntidsinformasjon om kollektivtransport kan gjøre hverdagen enklere for tusenvis av reisende.",
  
  "what_we_offer": "Hva vi tilbyr",
  "what_we_offer_desc": "Alt du trenger for kollektivtransport",
  "offer_1_title": "Nærmeste stoppesteder",
  "offer_1_desc": "Finn nærmeste buss-, tog- og fergestoppesteder øyeblikkelig basert på din posisjon",
  "offer_2_title": "Sanntidsavganger",
  "offer_2_desc": "Se nøyaktige avgangstider oppdatert i sanntid fra Entur",
  "offer_3_title": "Ruteplanlegging",
  "offer_3_desc": "Beregn beste reiserute til din destinasjon, inkludert eventuelle bytter",
  "offer_4_title": "Multimodal transport",
  "offer_4_desc": "Vi viser alle typer kollektivtransport - buss, tog, trikk, t-bane, ferge og mer",
  
  "how_it_works": "Hvordan det fungerer",
  "how_it_works_desc": "Enkel og sikker teknologi",
  "how_it_works_text": "Ruty bruker din posisjon til å finne nærmeste stoppesteder og hente sanntidsdata fra Entur, Norges nasjonale register for kollektivtransport. Vi kombinerer denne informasjonen med kraftige rutealgoritmer for å gi deg de beste reiseforslagene.",
  "completely_free": "✓ Helt gratis - Tjenesten er helt gratis å bruke og krever ingen registrering. Alt du trenger er en nettleser og tillatelse til å dele din posisjon.",
  
  "behind_scenes": "Bak kulissene",
  "behind_scenes_desc": "Hvem vi er",
  "behind_scenes_text_1": "Ruty drives av Solsikka Systemer AS (org.nr. 996958159), et norsk selskap dedikert til å lage nyttige digitale tjenester.",
  "behind_scenes_text_2": "Vi brenner for å gjøre teknologi tilgjengelig og brukervennlig. Ruty er vårt bidrag til å gjøre kollektivtransport mer attraktivt ved å fjerne friksjon fra planleggingsprosessen.",
  
  "entur_title": "Entur AS",
  "entur_text": "All transportdata kommer fra Entur AS, som er ansvarlig for den nasjonale reiseplanleggeren og billettsystemet for kollektivtransport i Norge. Entur samler inn og kvalitetssikrer data fra over 60 transportselskaper og tilbyr dette gjennom åpne API-er.",
  "technology_title": "Teknologi",
  "technology_text": "Tjenesten er bygget med moderne webteknologi for å sikre rask ytelse og god brukeropplevelse på alle enheter - mobil, nettbrett og desktop.",
  
  "privacy_security": "Personvern og sikkerhet",
  "privacy_security_desc": "Dine data er trygge",
  "privacy_text": "Vi tar personvern på alvor. Din posisjon behandles kun lokalt i nettleseren og lagres ikke permanent på våre servere. Les mer i vår personvernerklæring.",
  
  "future_plans": "Fremtidsplaner",
  "future_plans_desc": "Vi utvikler kontinuerlig",
  "future_plans_intro": "Vi jobber kontinuerlig med å forbedre Ruty. Kommende funksjoner inkluderer:",
  "future_plan_1": "Lagrede favorittstoppesteder",
  "future_plan_2": "Forsinkelsevarsler",
  "future_plan_3": "Offline-funksjonalitet",
  "future_plan_4": "Flere språkalternativer",
  "future_plan_5": "Integrasjon med billettkjøp",
  
  "contact_us_title": "Kontakt oss",
  "contact_us_desc": "Vi vil gjerne høre fra deg",
  "contact_us_text": "Har du spørsmål, tilbakemeldinger eller forslag til forbedringer?",
  "go_to_contact": "Gå til kontaktside",
  
  "support_us_title": "Støtt oss",
  "support_us_desc": "Hold tjenesten gratis",
  "support_us_text": "Ruty er gratis å bruke og vil alltid være det. For å dekke driftskostnader viser vi ikke-påtrengende annonser. Ved å godta cookies hjelper du oss å holde tjenesten i gang.",
  "thank_you": "Takk for at du bruker Ruty! 🚌🚆⛴️",
  
  // Contact page
  "contact_title": "Kontakt oss",
  "contact_subtitle": "Vi vil gjerne høre fra deg! Enten du har spørsmål, tilbakemeldinger eller forslag til forbedringer.",
  "email_title": "E-post",
  "email_desc": "Send oss en e-post",
  "email_response": "Vi svarer vanligvis innen 1-2 virkedager",
  "company_info": "Firmainfo",
  "company_info_desc": "Organisasjonsdetaljer",
  "need_help": "Trenger du hjelp?",
  "need_help_desc": "Se vår hjelpeside for svar på vanlige spørsmål",
  "help_page_title": "Hjelp og FAQ – Ruty fergeapp",
  "help_page_description": "Få hjelp til å bruke Ruty. Svar på vanlige spørsmål om fergeavganger, posisjon, ruteplanlegging og varsler.",
  "go_to_help": "Gå til hjelpeside",
  "what_contact_about": "Hva kan du kontakte oss om?",
  "what_contact_about_desc": "Vi hjelper deg med disse områdene",
  
  "technical_support": "Teknisk støtte",
  "technical_support_desc": "Hjelp med tekniske problemer",
  "tech_issue_1": "Problemer med å finne stoppesteder",
  "tech_issue_2": "Feil i avgangstider eller ruteinformasjon",
  "tech_issue_3": "Tekniske feil eller bugs",
  "tech_issue_4": "Problemer med posisjon eller karttjenester",
  
  "feedback_title": "Tilbakemelding",
  "feedback_desc": "Dine forslag og innspill",
  "feedback_1": "Forslag til nye funksjoner",
  "feedback_2": "Forbedringer av eksisterende funksjonalitet",
  "feedback_3": "Brukeropplevelse og design",
  "feedback_4": "Generelle kommentarer",
  
  "legal_inquiries": "Juridiske henvendelser",
  "legal_inquiries_desc": "Formelle og juridiske saker",
  "legal_1": "Personvernspørsmål og GDPR-henvendelser",
  "legal_2": "Spørsmål om vilkår for bruk",
  "legal_3": "Copyright og immaterielle rettigheter",
  "legal_4": "Formelle henvendelser",
  
  "partnerships": "Samarbeid",
  "partnerships_desc": "Partnerskap og integrasjoner",
  "partnership_1": "Partnerskapsforespørsler",
  "partnership_2": "Annonseringsmuligheter",
  "partnership_3": "API-integrasjoner",
  "partnership_4": "Mediehenvendelser",
  
  "important_to_know": "Viktig å vite",
  "important_to_know_desc": "Les dette før du tar kontakt",
  "transport_data": "Transportdata:",
  "transport_data_text": "All informasjon om avganger og ruter kommer fra Entur AS. For spørsmål om selve transporttjenestene (forsinkelser, kanselleringer, billetter), kontakt det aktuelle transportselskapet eller Entur direkte.",
  "email_response_label": "E-postsvar:",
  "email_response_text": "Vi svarer på alle henvendelser, men det kan ta 1-2 virkedager. For øyeblikkelig hjelp, sjekk vår hjelpeside først.",
  "thanks_using": "Takk for at du bruker Ruty!",
  
  // Help page - all FAQ content
  "help_heading": "Hjelp & vanlige spørsmål",
  "help_intro": "Her finner du svar på de vanligste spørsmålene om hvordan du bruker Ruty.",
  "help_getting_started_title": "Kom i gang",
  "help_getting_started_subtitle": "Slik starter du med Ruty",
  "help_go_to": "Gå til",
  "help_homepage_link": "startsiden",
  "help_step_click_find_location": "Klikk på \"Finn min posisjon\"-knappen",
  "help_step_allow_location": "Godta at nettleseren får tilgang til din posisjon",
  "help_step_view_departures": "Se nærmeste stoppesteder og avganger",
  "help_tips_label": "💡 Tips:",
  "help_tip_plan_before_location": "For å planlegge en reise, skriv inn destinasjonen i søkefeltet før du klikker på posisjonsknappen.",
  "help_faq_section_title": "Vanlige spørsmål (FAQ)",
  "help_faq_nearest_stop_q": "Hvordan finner jeg nærmeste stoppested?",
  "help_faq_nearest_stop_a_intro": "Klikk på den store knappen \"Finn min posisjon\" på startsiden. Nettleseren vil be om tillatelse til å bruke din posisjon - klikk \"Tillat\" eller \"Allow\".",
  "help_faq_nearest_stop_a_followup": "Tjenesten finner automatisk det nærmeste stoppestedet og viser sanntidsavganger. Hvis du ønsker å se andre stoppesteder i nærheten, klikk på knappen igjen.",
  "help_faq_plan_trip_q": "Hvordan planlegger jeg en reise til en spesifikk destinasjon?",
  "help_faq_plan_trip_before": "Før du klikker på posisjonsknappen:",
  "help_faq_plan_trip_step_destination": "Skriv inn destinasjonen din i søkefeltet (f.eks. \"Oslo\", \"Fredrikstad\", \"Tistedal\")",
  "help_faq_plan_trip_step_routes": "Du får nå forslag til reiseruter med eventuelle overganger",
  "help_faq_plan_trip_outro": "Tjenesten viser de beste alternativene basert på gjeldende avgangstider.",
  "help_faq_location_missing_q": "Hvorfor vises ikke min posisjon?",
  "help_faq_location_missing_intro": "Dette kan ha flere årsaker:",
  "help_faq_location_denied_label": "Nettleseren har ikke tillatelse:",
  "help_faq_location_denied_body": "Du må godta at nettleseren får tilgang til din posisjon. Sjekk innstillingene i nettleseren din.",
  "help_faq_location_services_off_label": "Posisjonstjenester er av:",
  "help_faq_location_services_off_body": "Sørg for at GPS/posisjonstjenester er aktivert på enheten din.",
  "help_faq_location_gps_label": "Dårlig GPS-signal:",
  "help_faq_location_gps_body": "Prøv å gå ut i det fri eller nærmere et vindu.",
  "help_faq_location_private_label": "Privat nettleser-modus:",
  "help_faq_location_private_body": "Noen nettlesere blokkerer posisjonstjenester i inkognito-modus.",
  "help_faq_realtime_q": "Er avgangstidene sanntid?",
  "help_faq_realtime_a_intro": "Ja! Vi henter sanntidsdata fra Entur, som samler inn oppdatert informasjon fra alle transportselskaper i Norge. Dette betyr at:",
  "help_faq_realtime_delay": "Forsinkelser vises automatisk",
  "help_faq_realtime_cancelled": "Kanselleringer fjernes fra listen",
  "help_faq_realtime_new": "Nye avganger legges til fortløpende",
  "help_important_label": "Viktig:",
  "help_faq_realtime_buffer_note": "I sjeldne tilfeller kan det være forsinkelse i dataoppdateringen fra transportselskapet. Vi anbefaler derfor alltid å ha litt buffer i planleggingen.",
  "help_faq_transport_types_q": "Hvilke transporttyper støttes?",
  "help_faq_transport_types_intro": "Ruty viser alle typer kollektivtransport i Norge:",
  "help_faq_transport_bus": "🚌 Buss (lokale og ekspressbusser)",
  "help_faq_transport_train": "🚆 Tog (NSB, Vy, lokaltog)",
  "help_faq_transport_tram": "🚊 Trikk",
  "help_faq_transport_metro": "🚇 T-bane",
  "help_faq_transport_ferry": "⛴️ Ferge og hurtigbåt",
  "help_faq_transport_airport_bus": "✈️ Flybuss til/fra flyplasser",
  "help_faq_transport_coverage": "Data dekker hele Norge og oppdateres kontinuerlig fra Entur.",
  "help_faq_privacy_storage_q": "Lagres min posisjon eller søkehistorikk?",
  "help_faq_privacy_storage_no": "Nei!",
  "help_faq_privacy_storage_body": "Din posisjon behandles kun lokalt i nettleseren din og sendes bare til Entur for å hente stoppesteder og avganger. Vi lagrer ikke din posisjon eller søkehistorikk på våre servere.",
  "help_faq_privacy_read_more": "Les mer om hvordan vi håndterer personvern i vår",
  "help_privacy_policy_link": "personvernerklæring",
  "help_faq_offline_q": "Kan jeg bruke tjenesten uten internett?",
  "help_faq_offline_body": "Nei, Ruty krever internettforbindelse for å hente sanntidsdata fra Entur. Både avgangstider og ruteinformasjon hentes direkte fra Enturs API-er og oppdateres kontinuerlig.",
  "help_tips_short_label": "Tips:",
  "help_faq_offline_future": "Offline-funksjonalitet er på vår liste over fremtidige funksjoner!",
  "help_faq_radius_q": "Hvorfor ser jeg ikke alle stoppesteder?",
  "help_faq_radius_body": "Tjenesten viser kun stoppesteder innenfor en viss radius (normalt 500-1000 meter) fra din posisjon for å holde informasjonen relevant og oversiktlig.",
  "help_faq_radius_options_intro": "Hvis du ønsker å se stoppesteder lenger unna, kan du:",
  "help_faq_radius_option_planner": "Bruke ruteplanleggeren med din destinasjon",
  "help_faq_radius_option_zoom": "Zoome ut på kartet (hvis tilgjengelig)",
  "help_faq_radius_option_move": "Flytte deg fysisk nærmere det aktuelle området",
  "help_faq_tickets_q": "Kan jeg kjøpe billetter via Ruty?",
  "help_faq_tickets_intro": "Nei, for øyeblikket støtter ikke Ruty billettkjøp. For å kjøpe billetter må du:",
  "help_faq_tickets_entur": "Bruke Entur-appen",
  "help_faq_tickets_operator": "Det aktuelle transportselskapets app eller nettside",
  "help_faq_tickets_onboard": "Kjøpe billett direkte hos sjåfør/konduktør (hvis tilgjengelig)",
  "help_faq_tickets_future": "Billettkjøp-integrasjon er planlagt for en fremtidig versjon.",
  "help_faq_mobile_q": "Fungerer tjenesten på mobil?",
  "help_faq_mobile_body": "Ja! Ruty er optimalisert for alle enheter - mobil, nettbrett og desktop. Designet er responsivt og tilpasser seg automatisk til skjermstørrelsen din.",
  "help_faq_mobile_no_app": "Du trenger ingen app-nedlasting. Bare åpne",
  "help_faq_mobile_browser": "i nettleseren din.",
  "help_troubleshooting_title": "Feilsøking",
  "help_troubleshooting_subtitle": "Løsninger på vanlige problemer",
  "help_trouble_loading_title": "Tjenesten laster ikke",
  "help_trouble_loading_subtitle": "Prøv disse løsningene",
  "help_trouble_loading_check_internet": "Sjekk internettforbindelsen din",
  "help_trouble_loading_refresh": "Prøv å oppdatere siden (F5 eller Cmd+R)",
  "help_trouble_loading_clear_cache": "Tøm nettleserens cache",
  "help_trouble_loading_other_browser": "Prøv en annen nettleser",
  "help_trouble_departures_title": "Avgangene vises ikke",
  "help_trouble_departures_subtitle": "Mulige årsaker og løsninger",
  "help_trouble_departures_check_permission": "Sørg for at du har godtatt posisjonstillatelse",
  "help_trouble_departures_near_stop": "Sjekk at du er i nærheten av et stoppested",
  "help_trouble_departures_schedule": "Noen stoppesteder har kun avganger på bestemte tider (rush, helg, etc.)",
  "help_trouble_departures_entur_prefix": "Det kan være planlagt vedlikehold hos Entur (sjekk",
  "help_trouble_data_title": "Feil i ruteinformasjon",
  "help_trouble_data_subtitle": "Rapporter datakvalitetsproblemer",
  "help_trouble_data_contact_prefix": "Hvis du oppdager feil i avgangstider, ruter eller stoppestednavn, kontakt",
  "help_trouble_data_entur_link": "Entur direkte",
  "help_trouble_data_entur_suffix": "da de er ansvarlige for dataen. Vi viser kun informasjonen vi får fra deres systemer.",
  "help_contact_cta_title": "Fant du ikke svar?",
  "help_contact_cta_subtitle": "Vi hjelper deg gjerne videre",
  "help_contact_cta_body": "Kontakt oss for ytterligere assistanse. Vi svarer normalt innen 1-2 virkedager.",

  // Privacy page
  "privacy_title": "Personvernerklæring - Ruty",
  "privacy_description": "Les hvordan Ruty håndterer dine personopplysninger, cookies og GDPR-rettigheter.",
  "privacy_heading": "Personvernerklæring",
  "last_updated": "Sist oppdatert",
  "privacy_intro": "Solsikka Systemer AS (org.nr. 996958159) (\"vi\", \"oss\", \"vår\") driver Ruty (ruty.no). Denne personvernerklæringen forklarer hvordan vi samler inn, bruker og beskytter dine personopplysninger.",
  
  "data_we_collect": "Hvilke data vi samler inn",
  "position_data": "Posisjonsdata",
  "position_data_text": "Vi ber om tilgang til din posisjon for å finne nærmeste stoppesteder og beregne ruter. Posisjonsdata behandles kun lokalt i nettleseren din og lagres ikke permanent på våre servere. Data sendes kun til Entur AS for å hente sanntidsinformasjon om kollektivtransport.",
  "cookies_local_storage": "Cookies og lokal lagring",
  "cookies_usage_intro": "Vi bruker cookies og localStorage for å:",
  "remember_consent": "Huske ditt samtykke til cookies",
  "improve_experience": "Forbedre brukeropplevelsen",
  "analyze_usage": "Analysere bruk av tjenesten",
  "google_analytics_heading": "Google Analytics",
  "google_analytics_text": "Vi bruker Google Analytics for å samle anonym statistikk om bruk av tjenesten. Dette inkluderer:",
  "page_views": "Sidevisninger og navigasjonsmønstre",
  "device_info": "Enhetsinformasjon (type, nettleser, skjermstørrelse)",
  "geographic_location": "Geografisk plassering (by-nivå)",
  "time_spent": "Tid brukt på siden",
  "google_adsense_heading": "Google AdSense",
  "google_adsense_text": "Vi viser annonser via Google AdSense. Annonser kan være basert på din nettleseraktivitet og innholdet på siden. Google kan bruke cookies til å vise relevante annonser.",
  
  "how_we_use_data": "Hvordan vi bruker dataene",
  "how_we_use_intro": "Vi bruker innsamlede data til å:",
  "show_transport": "Vise nærmeste kollektivtransport og beregne ruter",
  "improve_service": "Forbedre tjenesten og brukeropplevelsen",
  "analyze_patterns": "Analysere bruksmønstre for å optimalisere funksjonalitet",
  "show_ads_future": "Vise relevante annonser",
  
  "sharing_third_parties": "Deling med tredjeparter",
  "sharing_intro": "Vi deler data med følgende tredjeparts-tjenester:",
  "entur_heading": "Entur AS",
  "entur_privacy_text": "Din posisjon sendes til Entur for å hente sanntidsdata om kollektivtransport.",
  "read_more_entur": "Les mer om Enturs personvern på",
  "google_analytics_sharing": "Anonym bruksstatistikk deles med Google for analyse.",
  "read_more_google": "Les mer om Googles personvern på",
  "google_adsense_sharing": "Google AdSense kan bruke cookies til å vise personaliserte annonser. Du kan administrere dine annonsepreferanser på",
  "lovable_supabase": "Lovable/Supabase",
  "lovable_text": "Tjenesten hostes på Lovable Cloud (Supabase). Teknisk infrastruktur og logging håndteres av disse tjenestene.",
  
  "your_rights_gdpr": "Dine rettigheter (GDPR)",
  "gdpr_intro": "I henhold til GDPR har du følgende rettigheter:",
  "right_access": "Rett til innsyn:",
  "right_access_desc": "Be om en kopi av dine personopplysninger",
  "right_rectification": "Rett til retting:",
  "right_rectification_desc": "Korrigere unøyaktige opplysninger",
  "right_erasure": "Rett til sletting:",
  "right_erasure_desc": "Be om at vi sletter dine data",
  "right_restriction": "Rett til begrensning:",
  "right_restriction_desc": "Begrense behandlingen av dine data",
  "right_object": "Rett til protest:",
  "right_object_desc": "Protestere mot behandling av dine data",
  "right_portability": "Rett til dataportabilitet:",
  "right_portability_desc": "Få dine data i et maskinlesbart format",
  "exercise_rights": "For å utøve disse rettighetene, kontakt oss på kontaktinformasjonen nedenfor.",
  
  "data_security": "Datasikkerhet",
  "data_security_intro": "Vi tar datasikkerhet på alvor og bruker tekniske og organisatoriske tiltak for å beskytte dine personopplysninger:",
  "https_encryption": "HTTPS-kryptering for all kommunikasjon",
  "minimal_storage": "Minimal datalagring - kun nødvendig informasjon",
  "regular_updates": "Regelmessige sikkerhetsoppdateringer",
  
  "children_privacy": "Barn og personvern",
  "children_text": "Vår tjeneste er ikke rettet mot barn under 16 år. Vi samler ikke bevisst inn personopplysninger fra barn. Hvis du er forelder/verge og oppdager at ditt barn har delt personopplysninger med oss, kontakt oss umiddelbart.",
  
  "changes_privacy": "Endringer i personvernerklæringen",
  "changes_text": "Vi kan oppdatere denne personvernerklæringen fra tid til annen. Vesentlige endringer vil bli varslet på nettsiden med oppdatert dato øverst i dokumentet.",
  
  "contact_us_privacy": "Kontakt oss",
  "contact_privacy_intro": "For spørsmål om personvern, dine rettigheter eller denne erklæringen, kontakt oss:",
  "company_name": "Solsikka Systemer AS",
  "org_number": "Org.nr",
  "email_label": "E-post",
  "website_label": "Nettside",
  
  "supervisory_authority": "Tilsynsmyndighet",
  "supervisory_intro": "Du har rett til å klage til Datatilsynet hvis du mener vi behandler dine personopplysninger i strid med personvernregelverket:",
  "datatilsynet": "Datatilsynet",
  "datatilsynet_address": "Postboks 458 Sentrum",
  "datatilsynet_postal": "0105 Oslo",
  "phone_label": "Telefon",
  
  // Cookie Policy page
  "cookie_policy_title": "Cookie-policy - Ruty",
  "cookie_policy_description": "Informasjon om cookies på Ruty. Hvilke cookies vi bruker, hvorfor vi bruker dem og hvordan du kan administrere cookie-innstillinger.",
  "cookie_policy_heading": "Cookie-policy",
  "cookie_intro": "Denne cookie-policyen forklarer hvordan Ruty (ruty.no) bruker cookies og lignende teknologier for å gjenkjenne deg når du besøker nettsiden vår.",
  
  "what_are_cookies": "Hva er cookies?",
  "what_cookies_text": "Cookies er små tekstfiler som lagres på din enhet (datamaskin, nettbrett eller mobiltelefon) når du besøker en nettside. Cookies brukes for å gjøre nettsider mer funksjonelle og gi nettsideeiere informasjon om hvordan nettsiden brukes.",
  
  "how_use_cookies": "Hvordan bruker vi cookies?",
  "cookie_types_intro": "Vi bruker følgende typer cookies:",
  
  "necessary_cookies": "Nødvendige cookies (strengt nødvendige)",
  "necessary_text": "Disse cookies er essensielle for at nettsiden skal fungere korrekt. De kan ikke slås av i våre systemer.",
  "cookie_name": "Cookie-navn",
  "purpose": "Formål",
  "duration": "Varighet",
  "cookie_consent_name": "cookie-consent",
  "cookie_consent_purpose": "Lagrer ditt samtykke til cookies",
  "one_year": "1 år",
  "local_storage": "localStorage",
  "local_storage_purpose": "Lagrer brukerpreferanser lokalt",
  "no_expiry": "Ingen utløpsdato",
  
  "analytics_cookies": "Analysecookies (ytelse)",
  "analytics_text": "Disse cookies lar oss telle besøk og trafikkilder slik at vi kan måle og forbedre ytelsen til nettsiden vår.",
  "provider": "Leverandør",
  "google_analytics": "Google Analytics",
  "distinguish_users": "Skiller mellom brukere",
  "two_years": "2 år",
  "twentyfour_hours": "24 timer",
  "limit_requests": "Begrenser antall forespørsler",
  "one_minute": "1 minutt",
  "analytics_anonymous": "Google Analytics samler anonym statistikk om bruk av nettsiden. Les mer om Google Analytics' personvernspraksis på",
  
  "advertising_cookies": "Annonsecookies",
  "advertising_text": "Vi bruker Google AdSense til å vise annonser. Disse cookies brukes til å vise relevante annonser basert på din nettleseraktivitet.",
  "experimental_ad": "Eksperimentell annonseeffektivitet",
  "three_months": "3 måneder",
  "ad_targeting": "Målretting av annonser",
  "manage_ad_prefs": "Du kan administrere dine annonsepreferanser på",
  
  "control_delete_cookies": "Hvordan kontrollere og slette cookies?",
  "cookie_consent_site": "Cookie-samtykke på nettsiden",
  "consent_text": "Når du besøker nettsiden vår for første gang, vil du se en cookie-banner hvor du kan godta eller avvise ikke-nødvendige cookies. Du kan når som helst endre ditt samtykke ved å klikke på \"Cookie-innstillinger\" i bunnen av siden.",
  
  "browser_settings": "Nettleserinnstillinger",
  "browser_control_intro": "De fleste nettlesere lar deg kontrollere cookies gjennom innstillingene. Du kan:",
  "delete_all_cookies": "Slette alle cookies",
  "block_all_cookies": "Blokkere alle cookies",
  "allow_first_party": "Tillate kun førstepartscookies",
  "notify_cookies": "Få varsling hver gang en nettside setter en cookie",
  
  "manage_cookies_browsers": "Slik styrer du cookies i populære nettlesere:",
  "chrome_settings": "Innstillinger → Personvern og sikkerhet → Cookies og andre nettstedsdata",
  "firefox_settings": "Innstillinger → Personvern og sikkerhet → Cookies og nettstedsdata",
  "safari_settings": "Innstillinger → Personvern → Cookies og nettstedsdata",
  "edge_settings": "Innstillinger → Cookies og tillatelser for område → Cookies og lagrede data",
  "cookie_warning": "Hvis du blokkerer cookies, kan enkelte funksjoner på nettsiden slutte å virke.",
  
  "third_party_cookies": "Tredjepartscookies",
  "third_party_cookies_intro": "I tillegg til våre egne cookies, kan tredjepartsleverandører sette cookies på din enhet:",
  "google_analytics_usage": "For bruksanalyse",
  "google_adsense_ads": "For å vise annonser",
  "no_control_text": "Vi har ingen kontroll over disse cookies og anbefaler at du leser disse selskapenes personvernspolicyer.",
  
  "cookie_updates": "Oppdateringer av cookie-policyen",
  "cookie_updates_text": "Vi kan oppdatere denne cookie-policyen fra tid til annen for å reflektere endringer i vår bruk av cookies. Vennligst sjekk denne siden regelmessig for oppdateringer.",
  
  "contact_cookies": "Hvis du har spørsmål om vår bruk av cookies, kontakt oss:",
  "more_privacy_info": "For mer informasjon om personvern, se vår",
  "privacy_policy_link": "personvernerklæring",
  
  // Terms page
  "terms_title": "Vilkår for bruk - Ruty",
  "terms_description": "Vilkår for bruk av Ruty. Les om dine rettigheter, ansvarsbegrensning og juridisk informasjon.",
  "terms_heading": "Vilkår for bruk",
  "terms_intro": "Velkommen til Ruty (ruty.no). Ved å bruke denne tjenesten godtar du følgende vilkår for bruk. Vennligst les disse vilkårene nøye før du bruker tjenesten.",
  
  "acceptance_terms": "Aksept av vilkår",
  "acceptance_text": "Ved å få tilgang til eller bruke Ruty, godtar du å være bundet av disse vilkårene. Hvis du ikke godtar vilkårene, må du ikke bruke tjenesten.",
  
  "service_description": "Beskrivelse av tjenesten",
  "service_desc_intro": "Ruty er en webbasert tjeneste som gir informasjon om kollektivtransport i Norge. Tjenesten:",
  "shows_nearest_stops": "Viser nærmeste stoppesteder basert på din posisjon",
  "realtime_departures": "Gir sanntidsinformasjon om avganger",
  "calculates_routes": "Beregner ruter mellom to punkter",
  "uses_entur_data": "Bruker data fra Entur AS og andre offentlige transportkilder",
  
  "service_use": "Bruk av tjenesten",
  "permitted_use": "Tillatt bruk",
  "permitted_intro": "Du har lov til å bruke Ruty til:",
  "personal_use": "Personlig, ikke-kommersiell bruk",
  "find_transport_info": "Finne informasjon om kollektivtransport",
  "plan_trips": "Planlegge reiser",
  
  "prohibited_use": "Forbudt bruk",
  "prohibited_intro": "Du har ikke lov til å:",
  "illegal_purposes": "Bruke tjenesten til ulovlige formål",
  "hack_service": "Forsøke å hacke, ødelegge eller forstyrre tjenesten",
  "copy_content": "Kopiere, reprodusere eller distribuere innhold fra tjenesten uten tillatelse",
  "automated_tools": "Bruke automatiserte verktøy (bots, scraping) for å samle data fra tjenesten",
  "abuse_infrastructure": "Misbruke eller overbelaste tjenestens infrastruktur",
  "bypass_security": "Omgå sikkerhetstiltak eller tilgangskontroller",
  
  "limitation_liability": "Ansvarsbegrensning",
  "information_accuracy": "Informasjonsnøyaktighet",
  "accuracy_intro": "Ruty baserer seg på data fra tredjeparter, primært Entur AS. Vi kan ikke garantere at:",
  "accurate_times": "Alle avgangstider er korrekte eller oppdaterte",
  "complete_info": "Informasjonen er fullstendig",
  "error_free": "Tjenesten fungerer feilfritt til enhver tid",
  "important_note": "Bruk alltid flere kilder og bekreft informasjon før du baserer viktige reisebeslutninger på vår tjeneste.",
  
  "availability": "Tilgjengelighet",
  "availability_intro": "Vi streber etter å holde tjenesten tilgjengelig 24/7, men vi garanterer ikke:",
  "always_available": "At tjenesten alltid vil være tilgjengelig",
  "free_errors": "At tjenesten er fri for feil eller avbrudd",
  "errors_fixed": "At eventuelle feil vil bli rettet",
  
  "external_liability": "Eksternt ansvar",
  "external_intro": "Solsikka Systemer AS er ikke ansvarlig for:",
  "lost_revenue": "Tapte inntekter, tapt fortjeneste eller andre økonomiske tap",
  "indirect_damages": "Indirekte skader som følge av bruk av tjenesten",
  "transport_problems": "Forsinkelser, kanselleringer eller andre problemer med kollektivtransport",
  "third_party_damages": "Skader forårsaket av tredjeparters tjenester (Entur, Google, etc.)",
  
  "intellectual_property": "Immaterielle rettigheter",
  "ip_intro": "Alt innhold på Ruty, inkludert design, kode, grafikk og tekst, eies av Solsikka Systemer AS eller våre lisensgivere. Du har ikke lov til å:",
  "copy_modify": "Kopiere, modifisere eller distribuere innholdet",
  "commercial_use": "Bruke innholdet i kommersielle produkter",
  "remove_notices": "Fjerne opphavsrettsmerknader eller andre notiser",
  "exception_entur": "Data fra Entur er underlagt Enturs egne lisensvilkår. Se",
  "for_more_info": "for mer informasjon.",
  
  "privacy_terms": "Personvern",
  "privacy_terms_text": "Din bruk av Ruty er også underlagt vår",
  "read_privacy": "Vennligst les denne for å forstå hvordan vi samler inn og bruker dine personopplysninger.",
  
  "third_party_services": "Tredjepartstjenester",
  "third_party_intro": "Ruty integrerer med følgende tredjepartstjenester:",
  "entur_transport_data": "Transportdata og sanntidsinformasjon",
  "google_analytics_analysis": "Bruksanalyse",
  "google_adsense_future": "Viser annonser via Google AdSense",
  "read_their_terms": "Disse tjenestene har sine egne vilkår og personvernspolicyer som du bør lese.",
  
  "terms_refund_heading": "Refusjon og oppsigelse",
  "terms_refund_text": "Ruty Pro er et løpende abonnement som kan sies opp når som helst via kundeportalen; tilgangen varer ut inneværende betalingsperiode. Angrerett: ved kjøp starter tjenesten umiddelbart etter den gratis prøveperioden. Ønsker du refusjon for en feilaktig belastning, kontakt oss via kontaktsiden. Our order process is conducted by our online reseller Paddle.com. Paddle.com is the Merchant of Record for all our orders. Paddle provides all customer service inquiries and handles returns.",

  "changes_terms": "Endringer i vilkårene",
  "changes_terms_text": "Vi forbeholder oss retten til å endre disse vilkårene når som helst. Vesentlige endringer vil bli varslet på nettsiden med oppdatert dato øverst i dokumentet. Fortsatt bruk av tjenesten etter endringer utgjør aksept av de nye vilkårene.",
  
  "termination": "Oppsigelse",
  "termination_intro": "Vi kan suspendere eller avslutte din tilgang til tjenesten umiddelbart og uten varsel hvis:",
  "violate_terms": "Du bryter disse vilkårene",
  "suspect_abuse": "Vi mistenker misbruk eller ulovlig aktivitet",
  "required_by_law": "Det kreves av lov eller myndigheter",
  
  "governing_law": "Gjeldende lov",
  "governing_text": "Disse vilkårene er underlagt norsk lov. Eventuelle tvister skal løses i norske domstoler, med Oslo tingrett som verneting.",
  
  "contact_terms": "Hvis du har spørsmål om disse vilkårene, kontakt oss:",
  
  "disclaimer": "Ansvarsfraskrivelse",
  "disclaimer_text": "RUTY TILBYS \"SOM DEN ER\" UTEN GARANTIER AV NOE SLAG, VERKEN UTTRYKKELIGE ELLER UNDERFORSTÅTTE. BRUK AV TJENESTEN SKJER PÅ EGET ANSVAR.",
  
  // Homepage FAQ
  "faq_title": "Vanlige spørsmål",
  "faq_how_find_stop": "Hvordan finner jeg nærmeste stoppested?",
  "faq_how_find_stop_answer": "Klikk på posisjon-knappen (📍) ved siden av Fra-feltet. Nettleseren vil be om tillatelse til å bruke din posisjon. Tjenesten finner automatisk nærmeste stoppested og viser sanntidsavganger.",
  "faq_is_free": "Er tjenesten gratis?",
  "faq_is_free_answer": "Ja! Ruty er helt gratis å bruke. Vi finansieres gjennom annonser og krever ingen registrering eller abonnement.",
  "faq_works_norway": "Fungerer det i hele Norge?",
  "faq_works_norway_answer": "Ja, tjenesten dekker hele Norge. Vi henter sanntidsdata fra Entur som samler informasjon fra alle kollektivselskaper i landet - buss, tog, trikk, T-bane, ferge og fly.",
  "faq_realtime": "Er avgangstidene sanntid?",
  "faq_realtime_answer": "Ja! Vi viser sanntidsavganger fra Entur. Forsinkelser oppdateres automatisk, og kansellerte avganger fjernes fra listen.",
  "faq_mobile": "Fungerer tjenesten på mobil?",
  "faq_mobile_answer": "Ja, Ruty er optimalisert for alle enheter. Bare åpne ruty.no i nettleseren din - ingen app-nedlasting nødvendig.",
  "faq_popular_routes": "Hva er Populære ruter?",
  "faq_popular_routes_answer": "Populære ruter viser de mest søkte reisene de siste 7 dagene, oppdatert i sanntid. Trendindikatorene (Stiger/Stabil/Synker) viser om en rute blir mer eller mindre populær sammenlignet med forrige uke. Klikk på en rute for å starte et søk med avreise- og destinasjonsfeltet ferdig utfylt.",
  "faq_more_questions": "Flere spørsmål?",
  "faq_visit_help": "Besøk hjelpesiden",
  
  // Welcome Hero & Features
  "welcome_title": "Finn din neste reise",
  "welcome_subtitle": "Sanntid kollektivtransport for hele Norge",
  "feature_realtime_title": "Sanntidsdata",
  "feature_realtime_desc": "Oppdaterte avganger fra hele Norge",
  "feature_alltypes_title": "Alle transporttyper",
  "feature_alltypes_desc": "Buss, tog, trikk, T-bane, ferge, fly",
  "feature_free_title": "Gratis & enkelt",
  "feature_free_desc": "Ingen registrering nødvendig",
  "stats_searches_today": "søk i dag",
  "stats_routes_available": "1000+ ruter",
  
  // Ferry page
  "public_transport": "Kollektiv",
  "ferry_routes": "Fergeruter",
  "ferry_description": "Finn fergeruter i hele Norge",
  "ferry_page_title": "Fergeruter - Ruty",
  "ferry_page_description": "Finn fergeruter og avganger i Norge. Sanntidsinformasjon for alle fergesamband.",
  "from_ferry_placeholder": "Fra fergekai...",
  "to_ferry_placeholder": "Til fergekai...",
  "search_ferries": "Søk ferge",
  "no_ferry_routes": "Ingen fergeruter funnet",
  "ferry_realtime": "Sanntidsdata",
  "ferry_realtime_desc": "Oppdaterte fergeavganger",
  "ferry_routes_all": "Alle fergesamband",
  "ferry_routes_all_desc": "Hele Norge dekkes",
  "ferry_list_seo_title": "Alle fergesamband i Norge – Oversikt | Ruty",
  "ferry_list_seo_description": "Komplett oversikt over alle fergesamband i Norge med sanntid, trafikkstatus og live avgangstider.",
  "ferry_dock_list_seo_title": "Alle ferjekaier i Norge – Oversikt | Ruty",
  "ferry_dock_list_seo_description": "Oversikt over ferjekaier i Norge med lenker til avganger, kamera og sambandsinfo.",
  "ferry_docks_all": "Alle ferjekaier",
  "ferry_docks_all_desc": "Velg kai for å se avganger og info",
  "ferry_dock_list_crumb": "Kaier",
  "ferry_dock_list_search_placeholder": "Søk etter kai...",

  "ferry_on_route_live": "Live posisjon",
  "ferry_on_route_estimated": "Estimert posisjon",
  "ferry_on_route_waiting": "Ved kai (neste avgang)",
  "map_dock_sr": "Kai",
  "map_ferry_sr_yours": "Din ferje",
  "map_ferry_sr_other": "Ferje",
  "map_ferry_sr_at_dock": "ved kai i {dock}",
  "map_ferry_sr_heading_to": "på vei til {dock}",
  "map_ferry_sr_estimated": "beregnet posisjon",
  "ferry_on_route_at_dock": "Ved kai",
  "map_status_yours_at_dock": "Din ferje ligger ved kai i {dock} · går {time}",
  "map_status_yours_at_other": "Din ferje ligger ved kai i {dock} · er i {origin} {time}",
  "map_status_yours_sailing": "Din ferje er på vei til {dock} · fremme {time}",
  "map_status_your_departure": "Din avgang: {dock} {time}",
  "map_status_live": "live",
  "map_status_estimated": "estimert",
  "map_camera_open": "Åpne kamera ved kaia",
  "ferry_on_route_vessels_one": "1 ferge",
  "ferry_on_route_vessels_other": "{n} ferger",

  "ferry_types_list_seo_title": "Bilfergetyper i Norge – Samband og hvor de går | Ruty",
  "ferry_types_list_seo_description": "Oversikt over bilfergetyper i Norge: pendlerferge, stamveiferge, fjordferge, elektrisk bilferge, øysamband, lang overfart og kabelferge – med konkrete samband i Ruty.",
  "ferry_types_all": "Bilfergetyper i Norge",
  "ferry_types_all_desc": "Ruty handler om bilferger. Her ser du ulike typer bilferger, hvilke samband de typisk går på, og hvor i Norge du finner dem – med lenke til avganger.",
  "ferry_types_list_crumb": "Bilfergetyper",
  "ferry_types_list_search_placeholder": "Søk type, region eller samband…",
  "ferry_types_where_label": "Hvor i Norge",
  "ferry_types_tips_label": "Tips",
  "ferry_types_examples_label": "Kjente samband i Ruty",
  "ferry_types_routes_label": "Eksempelsamband i Ruty",
  "ferry_types_routes_intro": "Åpne et samband for neste avganger. Listen er eksempler – ikke alle bilferger i landet.",
  "ferry_types_read_more": "Les mer om typen og hvor den går →",
  "ferry_types_back_to_list": "Alle bilfergetyper",
  "ferry_types_models_title": "Typer bilferger",
  "ferry_types_models_intro": "Velg en type for å se typiske samband og hvor i Norge den brukes.",
  "ferry_types_toc_aria": "Hopp til bilfergetype",
  "ferry_types_empty": "Ingen typer matcher søket. Prøv «elektrisk», «Vestlandet» eller «Moss».",
  "ferry_types_faq_title": "Vanlige spørsmål om bilfergetyper",
  "ferry_types_faq_q1": "Hva er forskjellen på stamveiferge og fjordferge?",
  "ferry_types_faq_a1": "Stamveisamband fortsetter ofte riksvei/E-vei med høy kapasitet og frekvens. Fjordferger er klassiske lokale kryssinger – begge er bilferger, men rytme og kølogikk kan være forskjellig.",
  "ferry_types_faq_q2": "Er elektrisk bilferge en egen «reiseopplevelse»?",
  "ferry_types_faq_a2": "For deg som kjører er det fortsatt bilferge: samme kai, samme kø-tenkning. Forskjellen er drift og miljø – Ruty viser avganger uansett fremdrift.",
  "ferry_types_faq_q3": "Hvordan finner jeg hvor en type går i Norge?",
  "ferry_types_faq_a3": "Åpne typen under Bilfergetyper – der står regioner og eksempelsamband. Klikk et samband for neste avganger i Ruty.",
  "ferry_types_disclaimer": "Dette er en generell oversikt over bilfergetyper. Avgangstider, kapasitet og billetter varierer per samband – sjekk alltid sambandsiden eller rederiet før du reiser.",
  "ferry_types_regions_title": "Hvor i Norge finner du bilferger?",
  "ferry_types_regions_intro": "Eksempler fra samband Ruty viser – ikke en komplett liste over alle ferger i landet.",
  "ferry_types_visual_alt": "Illustrasjon av bilferge med biler på dekk",
  "ferry_types_visual_caption": "Illustrasjon: bilferge – du kjører om bord og fortsetter på veien etter overfarten.",
  "ferry_types_electric_note": "Mange norske bilferger er elektriske eller under omstilling. For deg som reisende er det samme logikk: sjekk avgang, kø og kai i Ruty.",
  "ferry_types_hero_tip": "Ruty viser bilferger – se typer og hvilke samband de går på.",
  "ferry_types_hero_tip_link": "Bilfergetyper",
  "ferry_types_region_oslofjorden_title": "Oslofjorden",
  "ferry_types_region_oslofjorden_desc": "Pendlerferger over fjorden – høy frekvens, ofte kø i rushtid og helger.",
  "ferry_types_region_vestlandet_title": "Vestlandet",
  "ferry_types_region_vestlandet_desc": "Klassiske fjordferger på riks- og fylkesveier – korte kryssinger og lengre fjordsamband.",
  "ferry_types_region_trondelag-helgeland_title": "Trøndelag & Helgeland",
  "ferry_types_region_trondelag-helgeland_desc": "Kyst- og øyforbindelser i midtre Norge – lokale bilferger mellom kaiene.",
  "ferry_types_region_nord-norge_title": "Nord-Norge",
  "ferry_types_region_nord-norge_desc": "Lengre øy- og kystsamband – vær og sesong kan påvirke frekvens mer enn lenger sør.",
  "ferry_types_region_sorlandet_title": "Sørlandet / innlandet",
  "ferry_types_region_sorlandet_desc": "Sjeldnere samband, blant annet kabelferger over innsjøer og korte sund.",
  "home_all_ferry_types_title": "Bilfergetyper",
  "home_all_ferry_types_desc": "Typer bilferger og hvilke samband de går på",

  "ferry_type_bilferge_title": "Hva er en bilferge?",
  "ferry_type_bilferge_summary": "Kjøretøyferge som fortsetter veinettet over fjord eller sund – med bil, motorsykkel, sykkel og fotgjengere om bord.",
  "ferry_type_bilferge_body": "Du kjører om bord, krysser vannet, og fortsetter på veien. Frekvens, kø og billettregler avgjør ofte om du rekker avgangen – derfor viser Ruty neste avganger per samband og kai.",
  "ferry_type_bilferge_where": "Langs kysten der veien krysser vann – særlig Vestlandet, Oslofjorden, Helgeland og Nord-Norge.",
  "ferry_type_bilferge_tips": "Sjekk billett/AutoPASS, kom tidlig ved kø, og åpne sambandsiden for neste avgang før du kjører til kai.",

  "ferry_type_pendlerferge_title": "Pendlerferge",
  "ferry_type_pendlerferge_summary": "Høyfrekvent bilferge på pendlerstrekninger – mange avganger, ofte kø i rushtid.",
  "ferry_type_pendlerferge_body": "Pendlerferger binder byer og arbeidsmarkeder over vann. For deg som kjører er timing og kø viktigere enn «turisttempo» – sjekk neste avgang før du kjører til kai.",
  "ferry_type_pendlerferge_where": "Særlig Oslofjorden, f.eks. Moss–Horten.",
  "ferry_type_pendlerferge_tips": "Kom tidlig i rushtid og helger. AutoPASS/billettregler følger sambandet – se sambandsiden i Ruty.",
  "ferry_type_pendlerferge_seo_title": "Pendlerferge i Norge – Samband og avganger | Ruty",
  "ferry_type_pendlerferge_seo_description": "Hva en pendlerferge er, hvor i Norge den går, og eksempelsamband som Moss–Horten med avganger i Ruty.",

  "ferry_type_stamveisamband_title": "Stamvei- / E-veiferge",
  "ferry_type_stamveisamband_summary": "Store bilferger som fortsetter riksvei eller europavei over fjord – høy kapasitet og ofte høy frekvens.",
  "ferry_type_stamveisamband_body": "Stamveisamband er «veien videre» for langtur og næringstransport. Kø, kapasitet og billettsystem er det som avgjør om du rekker over – ikke om ferga er «stor» i seg selv.",
  "ferry_type_stamveisamband_where": "Særlig Vestlandet og Trøndelag (E39 og andre stamveilenker).",
  "ferry_type_stamveisamband_tips": "Sjekk frekvens og køtips på sambandsiden. Mange har AutoPASS eller ferjekort.",
  "ferry_type_stamveisamband_seo_title": "Stamveiferge i Norge – E39 og riksvei-samband | Ruty",
  "ferry_type_stamveisamband_seo_description": "Stamvei- og E-veiferger i Norge: hvor de går, og samband som Mortavika–Arsvågen, Lavik–Oppedal og Rørvik–Flakk.",

  "ferry_type_fjordferge_title": "Klassisk fjordferge",
  "ferry_type_fjordferge_summary": "Lokal bilferge over fjord eller sund – typisk dobbeltendet, drive-on/drive-off i begge ender.",
  "ferry_type_fjordferge_body": "Fjordsamband er hverdagsveien for mange kystkommuner. Kortere overfarter, lokale kai og rytme som følger fylkesvei – fortsatt bilferge, bare mer «lokal» enn E-veikryssingene.",
  "ferry_type_fjordferge_where": "Særlig Vestlandet – Sognefjorden, Hardanger, Rogaland og lignende fjordarmer.",
  "ferry_type_fjordferge_tips": "Sjekk om det er kø i høysesong. Små samband kan ha færre avganger kveld og natt.",
  "ferry_type_fjordferge_seo_title": "Fjordferge i Norge – Lokale bilferger og samband | Ruty",
  "ferry_type_fjordferge_seo_description": "Klassiske fjordferger i Norge: hvor de går, og eksempelsamband som Mannheller–Fodnes og Solvorn–Ornes.",

  "ferry_type_elektrisk-bilferge_title": "Elektrisk bilferge",
  "ferry_type_elektrisk-bilferge_summary": "Batterielektrisk (eller nullutslipps) bilferge – samme bruk for deg som kjører, annen drift bak kulissene.",
  "ferry_type_elektrisk-bilferge_body": "Norge var tidlig ute med el-bilferger på korte, travle samband. For reisende er kai, kø og avgang det som teller; fremdriftstype står sjelden i rutetabellen.",
  "ferry_type_elektrisk-bilferge_where": "Særlig Vestlandet på korte, frekvente kryssinger med ladning ved kai.",
  "ferry_type_elektrisk-bilferge_tips": "Planlegg som vanlig bilferge: sjekk neste avgang og kø. El-drift endrer sjelden hvordan du bruker sambandet.",
  "ferry_type_elektrisk-bilferge_seo_title": "Elektrisk bilferge i Norge – Samband og avganger | Ruty",
  "ferry_type_elektrisk-bilferge_seo_description": "Elektriske bilferger i Norge: hvor de går, og samband som Lote–Anda, Festøya–Solavågen og Lavik–Oppedal.",

  "ferry_type_oy-kystsamband_title": "Øy- og kystsamband",
  "ferry_type_oy-kystsamband_summary": "Bilferge som knytter øyer og kyststrekninger – ofte lengre mellom kaiene enn en kort fjordhopp.",
  "ferry_type_oy-kystsamband_body": "Øy- og kystsamband er livsnerven for mange samfunn uten fastlandsbro. Vær, sesong og kapasitet kan bety mer enn på korte stamveikryssinger.",
  "ferry_type_oy-kystsamband_where": "Særlig Nord-Norge, Helgeland og Trøndelagskysten.",
  "ferry_type_oy-kystsamband_tips": "Sjekk vær og sesongruter. Noen samband har færre avganger utenom sommer.",
  "ferry_type_oy-kystsamband_seo_title": "Øy- og kystbilferge i Norge – Samband | Ruty",
  "ferry_type_oy-kystsamband_seo_description": "Øy- og kystsamband med bilferge i Norge: Bodø–Moskenes, Stokkvågen–Lovund, Levang–Nesna og flere i Ruty.",

  "ferry_type_lang-overfart_title": "Lang overfart",
  "ferry_type_lang-overfart_summary": "Bilferge med lengre overfartstid – mer planlegging enn en kort fjordkryssing.",
  "ferry_type_lang-overfart_body": "Lange overfarter krever mer buffer i reiseplanen. Frekvens kan være lavere, og vær kan påvirke mer – fortsatt bilferge, men med annen tidslogikk.",
  "ferry_type_lang-overfart_where": "Særlig Nord-Norge (øy- og kystlenker med lengre distanse).",
  "ferry_type_lang-overfart_tips": "Planlegg med margin. Sjekk avgang og eventuelle sesongendringer før du kjører til kai.",
  "ferry_type_lang-overfart_seo_title": "Lang bilferge-overfart i Norge – Samband | Ruty",
  "ferry_type_lang-overfart_seo_description": "Lange bilferge-overfarter i Norge: hvor de går, og samband som Bodø–Moskenes og Lødingen–Bognes.",

  "ferry_type_kabelferge_title": "Kabelferge",
  "ferry_type_kabelferge_summary": "Bilferge styrt langs kabel – typisk svært korte kryssinger over innsjø eller sund.",
  "ferry_type_kabelferge_body": "Kabelferger er en egen teknisk løsning: ferga følger kabel mellom kaiene. For deg som kjører er det fortsatt «kjør om bord», men sambandet er ofte lite og lokalt.",
  "ferry_type_kabelferge_where": "Sjeldne samband, blant annet innlands-/sørnorske korte kryssinger (f.eks. Nissedal).",
  "ferry_type_kabelferge_tips": "Sjekk åpningstider – mange kabelferger har begrenset drift sammenlignet med store stamveisamband.",
  "ferry_type_kabelferge_seo_title": "Kabelferge i Norge – Samband og avganger | Ruty",
  "ferry_type_kabelferge_seo_description": "Kabelferger i Norge: hva de er, hvor de går, og samband som Nissedal–Fjone med info i Ruty.",

  // Ferry feature cards
  "ferry_feature_realtime": "Sanntid",
  "ferry_feature_realtime_desc": "Oppdaterte fergeavganger",
  "ferry_feature_routes": "Alle ferger",
  "ferry_feature_routes_desc": "Bilferger og hurtigbåter",
  "ferry_feature_docks": "Fergekaier",
  "ferry_feature_docks_desc": "Finn nærmeste samband",
  
  // Ferry live stats
  "ferry_searches_today": "fergesøk i dag",
  "ferry_docks_available": "500+ fergekaier",
  
  // Ferry popular routes
  "popular_ferry_routes": "Populære fergeruter",
  "no_popular_ferry_routes": "Ingen populære fergeruter ennå",
  "be_first_ferry_search": "Bli den første til å søke etter fergeruter!",
  
  // Ferry FAQ
  "ferry_faq_title": "Spørsmål om ferger",
  "ferry_faq_find_dock": "Hvordan finner jeg nærmeste ferjekai?",
  "ferry_faq_find_dock_answer": "Klikk på 'Min posisjon'-knappen. Appen finner automatisk de nærmeste ferjeleiene og viser avgangstider for ferger.",
  "ferry_faq_realtime": "Vises sanntidsdata for ferger?",
  "ferry_faq_realtime_answer": "Ja! Vi henter sanntidsdata fra Entur som inkluderer fergeavganger fra alle rederier i Norge. Forsinkelser oppdateres automatisk.",
  "ferry_faq_coverage": "Hvilke fergeruter dekkes?",
  "ferry_faq_coverage_answer": "Vi dekker alle bilferger, hurtigbåter og passasjerferger i Norge - fra Hurtigruten til lokale fjordferger og øyferger.",
  "ferry_faq_car": "Kan jeg se om fergen tar biler?",
  "ferry_faq_car_answer": "Avgangsinformasjonen viser hvilken type ferge det er. Bilferger er merket spesielt, men for kapasitet anbefaler vi å sjekke rederiets egne nettsider.",
  "ferry_faq_weather": "Påvirker været fergeavgangene?",
  "ferry_faq_weather_answer": "Ja, ferger kan bli innstilt ved dårlig vær. Kanselleringer oppdateres i sanntid i appen når rederiene melder fra.",

  // Departure source pill (Sanntid / Planlagt)
  "departure_source_realtime": "Sanntid",
  "departure_source_scheduled": "Planlagt",
  "departure_source_realtime_tooltip": "Sanntidsdata fra Entur",
  "departure_source_scheduled_tooltip": "Planlagt rutetid",

  // Departure status pill
  "departure_status_on_time": "I rute",
  "departure_status_delayed": "Forsinket",
  "departure_status_cancelled": "Innstilt",
  "departure_status_no_realtime": "Ingen sanntid",

  // Traffic badge
  "traffic_low": "Rolig",
  "traffic_medium": "Middels",
  "traffic_high": "Mye",
  "traffic_low_desc": "Kort ventetid forventet",
  "traffic_medium_desc": "Noe ventetid kan forekomme",
  "traffic_high_desc": "Lang ventetid – kom tidlig!",
  "traffic_badge_tooltip": "Estimat basert på tidspunkt, ukedag og sesong",

  // Departure confidence
  "confidence_good": "Rekker den",
  "confidence_maybe": "Kan bli knapt",
  "confidence_no": "Rekker ikke",
  "confidence_good_tooltip": "Du har god tid til å nå denne ferga",
  "confidence_maybe_tooltip": "Knapt – vurder å kjøre nå",
  "confidence_no_tooltip": "Du rekker sannsynligvis ikke denne avgangen",
  "confidence_what_means": "Hva betyr dette?",
  "confidence_maybe_explain": "Basert på kjøretid og avgangstid er det knapt. Trafikk eller forsinkelser kan gjøre at du ikke rekker det.",
  "confidence_no_explain": "Det er for lite tid igjen til å nå denne avgangen med normal kjøretid. Se neste avgang.",
  "catch_light_heading": "Rekker du ferga?",
  "catch_answer_make": "Du rekker {time}",
  "catch_answer_tight": "Knapt: {time}",
  "catch_answer_none_until": "Ingen avgang du rekker frem til {time}",
  "catch_answer_no_departures": "Fant ingen avganger",
  "catch_arrives": "fremme {time}",
  "catch_leave_by": "Kjør senest {time}",
  "catch_leave_now": "Kjør nå",
  "arrival_prefix": "Fremme",
  "catch_time_tomorrow": "{time} i morgen",
  "catch_missed": "Du rekker ikke {time}",
  "catch_buffer_note": "Beregnet med {n} min oppmøte på kaia",
  "traffic_busy_hint": "Ofte travelt på denne tiden – kom gjerne litt tidlig.",
  "catch_light_green": "Rekker",
  "catch_light_yellow": "Knapt",
  "catch_light_red": "Rekker ikke",
  "catch_light_red_with_time": "For sent · {time}",
  "catch_light_missed_detail": "Du rakk ikke avgangen {time}. Se neste avganger under.",
  "catch_light_reason_returning": "Ferga er på vei tilbake til kaien nærmest deg – den telles som neste ferge.",
  "catch_light_reason_makes_next": "Du har god margin til neste avgang fra din kai.",
  "catch_light_reason_tight": "Neste avgang er tett – vurder å kjøre nå.",
  "catch_light_reason_left_your_side": "Ferga har gått fra din side av sambandet.",
  "catch_light_reason_misses_next": "Du rekker sannsynligvis ikke neste avgang. Se senere avganger.",
  "catch_light_reason_unknown": "Ingen kommende avgang funnet for din kai.",
  "sailing_crossing_duration": "{n} min overfart",
  "sailing_remaining": "{n} min igjen",
  "sailing_on_water": "På sjøen",
  "sailing_next": "Neste overfart",
  "sailing_underway": "Underveis",
  "sailing_not_departed": "Har ikke gått ennå",
  "refine_stretch": "Endre strekning",
  "refine_stretch_open": "Vis",
  "refine_stretch_close": "Skjul",
  "map_follow_ferry": "Følg ferge",
  "confidence_see_details": "Se alle avganger",

  // Pendler-modus
  "commuter_suggestion": "Du søker ofte denne ruten",
  "commuter_save": "Lagre som fast rute",
  "commuter_saved_routes": "Faste ruter",
  "commuter_dismiss": "Ikke nå",
  "commuter_refresh": "Oppdater resultater",

  // Pinned next departure alerts
  "pinned_alert_no": "Du rekker ikke neste – prøv avgangen etter",
  "pinned_alert_maybe": "Kan bli knapt – dra nå!",
  "pinned_open_dock": "Åpne kai",
  "commuter_rec_go_now": "Vurder å dra nå – kan bli knapt",
  "commuter_rec_leave_soon": "Begynn å gjøre deg klar",
  "commuter_rec_good_margin": "Du har god margin",
  "commuter_direction_work": "Prioriterer jobbretning",
  "commuter_direction_home": "Prioriterer hjemretning",

  // Least queue section
  "least_queue_title": "Når er det minst kø?",
  "least_queue_desc": "Basert på historiske trafikkmønstre",
  "least_queue_best": "Beste tidspunkt",
  "least_queue_avoid": "Unngå",

  // Geolocation errors
  "geo_permission_denied": "Lokasjon ikke tillatt",
  "geo_open_settings": "Åpne nettleserinnstillinger for å tillate posisjonering",
  "geo_unavailable": "Posisjonen din er utilgjengelig akkurat nå",
  "geo_timeout": "Det tok for lang tid å hente posisjonen din",
  "geo_retry": "Prøv igjen",

  // Push opt-in
  "push_enabled_label": "Varsler på",
  "push_disabled_label": "Få varsler",
  "push_permission_blocked": "Blokkert",

  // Push settings
  "push_settings_title": "Varslingsinnstillinger",
  "push_dock_label": "Varsler for kai",
  "push_quiet_hours": "Stille timer",
  "push_snooze_label": "Utsett varsler",
  "push_snoozed": "Utsatt",
  "snooze_1h": "1 time",
  "snooze_3h": "3 timer",
  "snooze_tomorrow": "Til i morgen",
  "push_last_sent": "Sist sendt",
  "push_why_no_notification": "Hvorfor du ikke får varsel nå",
  "push_test_send": "Send testvarsel",
  "push_unsubscribe_all": "Slå av alle varsler",
  "push_sensitivity_label": "Følsomhet",
  "push_preview_label": "Hvis cron kjørte nå",

  // Ferry home page
  "home_nearest": "Nærmeste",
  "home_plan_trip": "Planlegg reise",
  "home_search_samband": "Søk samband",
  "home_find_nearest": "Finn nærmeste samband",
  "home_hero_title": "Rekker du ferga?",
  "home_hero_subtitle": "Finner nærmeste samband, beregner kjøretid, viser neste avgang.",
  "home_add_title": "Legg til dine faste fergesamband her",
  "home_add_subtitle": "Få sanntid, kø-status og kamera rett på forsiden. Lagres lokalt – ingen innlogging nødvendig.",
  "home_add_button": "+ Legg til samband",
  "home_popular_title": "Populære fergesamband",
  "home_all_ferries_title": "Alle ferger",
  "home_all_ferries_desc": "Komplett oversikt over fergesamband",
  "home_all_docks_title": "Alle ferjekaier",
  "home_all_docks_desc": "Oversikt over kaier med avganger og info",
  "home_reminder_title": "Få påminnelse før avgang",
  "home_reminder_desc": "Aktiver varsler på dine fergesamband",
  "home_activate_alerts": "Aktiver varsler",

  // Ferry home page — Batch 3 nav + Mine ferger panel
  "nav_my_ferries": "Mine ferger",
  "nav_alerts": "Varsler",
  "nav_more": "Mer",
  "nav_my_profile": "Min profil",
  "myferries_next_departure": "NESTE AVGANG",
  "myferries_show_more": "Vis {n} flere",
  "myferries_create_alert": "Opprett varsel",
  "myferries_see_all_departures": "Se alle avganger",
  "myferries_see_all": "Se alle",

  // Time formatting (timeFormat facade — compound via t() templates)
  "time_just_now": "akkurat nå",
  "time_just_now_cap": "Akkurat nå",
  "time_tomorrow": "i morgen",
  "time_today": "i dag",
  "time_in_minutes": "om {n} min",
  "time_in_hours": "om {h} t",
  "time_in_hours_minutes": "om {h} t {m} min",
  "time_in_days": "om {n} dager",
  "time_hours_short": "t",
  "time_min_short": "min",
  "time_past_for_seconds": "for {n} sek siden",
  "time_past_for_minutes": "for {n} min siden",
  "time_past_minutes": "{n} min siden",
  "time_past_hours_minutes": "for {h} t {m} min siden",
  "time_past_hours_minutes_compact": "{h}t {m}min siden",
  "time_duration_hours_minutes": "{h} t {m} min",
  "time_duration_minutes": "{n} min",
  "time_duration_under_minute": "< 1 min",
  "time_drive_approx": "~{n} min",
  "time_drive_estimate": "ca. {n} min",
  "time_drive_ferry_approx": "〰 ~{n} min",
  "time_delay_plus": "+{n} min",
  "time_compound_hours_short": "{h}t {m}m",
  "time_travel_pill_minutes": "~{n} min",
  "time_travel_pill_hours": "~{h} t",
  "time_travel_pill_hours_minutes": "~{h} t {m} min",
  "time_travel_pill_ferry_minutes": "〰 ~{n} min",
  "time_travel_pill_ferry_hours": "〰 ~{h} t",
  "time_travel_pill_ferry_hours_minutes": "〰 ~{h} t {m} min",
  "time_tab_countdown": "🚢 {n} min – {title}",
  "time_day_today": "I dag",
  "time_minutes_before": "{n} min før",
  "time_minutes_remaining": "{n} min igjen",
  "time_seo_next_departure": "Se sanntids avgangstider for {title}. Neste avgang {countdown}.",
  "time_banner_urgent_prefix": "⏳ {name} går ",
  "time_banner_next": "Neste {name}:",
  "time_monitor_next_ferry": "⏰ Neste ferge fra {name} {countdown}",
  "time_alert_title": "Avgang {countdown}",
  "time_alert_description": "{route} kl. {clock} → {destination}",
  "time_margin_walk": "{n} min å gå på",
  "time_margin_label": "{n} min margin",
  "time_ferry_crossing_minutes": "Overfarten tar ca. {n} minutter.",
  "time_alert_notify_description": "Du blir varslet {before} neste avgang for {route}{suffix}.",
  "time_commuter_notify_description": "Du får varsel {before} før avgang fra {dock} på valgte dager.",
  "time_driving_mode_description": "Du får hyppigere varsler for {dock} i {duration}.",
  "time_create_alert_button": "Opprett varsel {before}",
  "time_lead_minutes_label": "{n} minutter før avgang",
  "time_before_departure": "{n} min før avgang",
  "time_ferry_crossing_badge": "Ca. {n} min overfartstid",
  "time_driving_alerts_next": "Aktiver hyppigere varsler for {dock} de neste {duration}.",
  "time_none_reachable_buffer": "Ingen rekkbare avganger de neste timene med {n} min margin.",
  "queue_report_low_status": "Lite kø rapportert",
  "queue_report_medium_status": "Middels kø",
  "queue_report_high_status": "Lang kø rapportert",
  "queue_report_option_low_label": "Lite kø",
  "queue_report_option_low_desc": "Kom rett på",
  "queue_report_option_medium_label": "Middels kø",
  "queue_report_option_medium_desc": "1–2 avganger ventetid",
  "queue_report_option_high_label": "Lang kø",
  "queue_report_option_high_desc": "3+ avganger ventetid",
  "queue_report_button": "Rapporter kø",
  "queue_report_button_done": "✓ Rapportert",
  "queue_report_sheet_title": "Rapporter kø – {dockName}",
  "queue_report_sheet_prompt": "Hvordan er køen akkurat nå?",
  "queue_report_anonymous_note": "Rapporten er anonym og hjelper andre sjåfører.",
  "queue_report_toast_thanks_title": "Takk for rapporten!",
  "queue_report_toast_thanks_desc": "Andre brukere kan nå se køstatusen.",
  "queue_report_toast_rate_limited_title": "Allerede rapportert",
  "queue_report_toast_rate_limited_desc": "Du kan rapportere igjen om noen minutter.",
  "queue_report_toast_error_desc": "Kunne ikke sende rapport.",
  "queue_report_reports_window": "siste 45 min",
  "queue_prediction_title": "Historisk kø denne tiden",
  "queue_level_low": "Lite kø",
  "queue_level_medium": "Middels kø",
  "queue_level_high": "Lang kø",
  "queue_prediction_based_on_zero": "Basert på {n} rapporter de siste {weeks} ukene",
  "queue_prediction_based_on_one": "Basert på {n} rapport de siste {weeks} ukene",
  "queue_prediction_based_on_two": "Basert på {n} rapporter de siste {weeks} ukene",
  "queue_prediction_based_on_few": "Basert på {n} rapporter de siste {weeks} ukene",
  "queue_prediction_based_on_many": "Basert på {n} rapporter de siste {weeks} ukene",
  "queue_prediction_based_on_other": "Basert på {n} rapporter de siste {weeks} ukene",
  "queue_prediction_report_count_zero": "{n} rapporter",
  "queue_prediction_report_count_one": "{n} rapport",
  "queue_prediction_report_count_two": "{n} rapporter",
  "queue_prediction_report_count_few": "{n} rapporter",
  "queue_prediction_report_count_many": "{n} rapporter",
  "queue_prediction_report_count_other": "{n} rapporter",
  "queue_prediction_low_data_warning": "Lite data – kan være unøyaktig",
  "queue_weekly_average_title": "Gjennomsnittlig kø per ukedag",
  "reach_title": "Rekker du fergen?",
  "reach_will_make_it": "Du rekker den",
  "reach_tight": "Usikkert – det blir trangt",
  "reach_too_late": "Du rekker ikke",
  "reach_gps_prompt": "Aktiver posisjon for å bruke denne funksjonen",
  "reach_retry": "Prøv igjen",
  "reach_at_dock": "Du er ved kaien 🎉",
  "reach_distance": "Du er ca. {distance} fra {dock}",
  "reach_drive_time_label": "Estimert kjøretid:",
  "reach_safety_margin_label": "Sikkerhetsmargin:",
  "reach_recommended_badge": "Anbefalt",
  "reach_estimate_disclaimer": "Estimat basert på luftlinje – faktisk kjøretid kan variere",
  "trust_state_down": "Sanntid utilgjengelig",
  "trust_cache": "Lagrede avganger",
  "trust_cache_with_age": "Lagrede avganger · {age}",
  "trust_refresh": "Oppdater",
  "trust_updated_ago": "oppdatert {age}",
  "trust_updating": "oppdaterer…",
  "nearby_no_car_ferry_title": "Ingen bilfergekai i nærheten",
  "nearby_no_car_ferry_desc": "Nærmeste bilferge er langt unna. Planlegg turen for å finne en rute dit.",
  "nearby_realtime_down_title": "Sanntid er midlertidig utilgjengelig.",
  "nearby_try_again_soon": "Prøv igjen om litt.",
  "nearby_fetch_failed_desc": "Kunne ikke finne fergekaier i nærheten",
  "route_realtime_temporarily_unavailable": "Sanntid midlertidig utilgjengelig",
  "route_departures_fetch_failed": "Kunne ikke hente avganger",
  "route_from_dock": "Fra {dock}",
  "route_no_departures_to": "Ingen avganger til {dock} funnet",
  "route_offline_last_updated": "⚠ Offline – sist oppdatert {age}",
  "route_via_partner": "innom {partner} → {destination}",
  "route_add_departure_aria": "Legg til avgang {time} til {destination} i kalender",
  "route_embed_title": "Legg til på din nettside",
  "route_embed_desc": "Kopier koden under for å vise avganger på din nettside:",
  "copy": "Kopier",
  "copied": "Kopiert!",
  "route_nearby_routes": "Andre populære samband i nærheten",
  "route_fav_added_title": "Lagt til i Mine ferger",
  "route_fav_added_desc": "Sambandet vises nå på hjemskjermen.",
  "route_fav_removed_title": "Fjernet fra Mine ferger",
  "route_fav_removed_desc": "Sambandet er fjernet fra hjemskjermen.",
  "route_free_limit_title": "Du har nådd grensen for gratis-planen",
  "route_free_limit_desc": "Oppgrader til Pro for å lagre flere enn {limit} samband.",
  "route_fav_save_failed_title": "Kunne ikke lagre favoritt",
  "route_not_found_title": "Sambandet ble ikke funnet",
  "route_not_found_desc": "Vi finner dessverre ikke fergesambandet du leter etter.",
  "route_back_to_ferry_search": "Tilbake til fergesøk",
  "route_seo_title": "{title} ferge – neste avgang | Ruty",
  "route_seo_desc_fallback": "Se sanntids avganger for {title}. Rutetabell og trafikkinformasjon.",
  "route_seohead_title": "{from}–{to} ferge – sanntid avganger ✓ rutetider og overfartstid",
  "route_seohead_desc": "Se sanntids avganger for {from}–{to}. Sjekk overfartstid, rutetider og køstatus. Gratis – ingen app nødvendig.",
  "route_seohead_title_fallback": "Fergesamband – sanntid avganger og rutetider",
  "route_seohead_desc_fallback": "Se sanntids avganger, rutetider og overfartstid for norske fergesamband. Gratis – ingen app nødvendig.",
  "back": "Tilbake",
  "route_share_title": "{from} – {to} ferge",
  "route_share_text": "Ferjeinformasjon for {from}–{to} på Ruty",
  "route_link_copied": "✓ Lenke kopiert",
  "route_link_copied_desc": "Del fergeinfoen med hvem du vil.",
  "route_copy_link_manually": "Kopier lenken manuelt",
  "route_share_failed": "Kunne ikke dele",
  "route_try_again": "Prøv igjen.",
  "route_share_ferry_info": "Del fergeinfo",
  "route_route_subtitle": "Fergesamband",
  "route_ruty_score": "Ruty Score: {score}/100",
  "route_create_alert_aria": "Opprett varsel for dette sambandet",
  "route_alert_subtitle": "Bli varslet før neste avgang",
  "route_taking_this_ferry": "Skal du ta denne fergen?",
  "route_about_route": "Om sambandet {title}",
  "route_payment": "Betaling",
  "route_follow_route_prompt": "Vil du følge dette sambandet?",
  "yes": "Ja",
  "no_thanks": "Nei takk",
  "route_save_tooltip": "Lagre for rask tilgang neste gang ⚡",
  "favorite": "Favoritt",
  "hide": "Skjul",
  "camera": "Kamera",
  "route_disable_alerts": "Skru av varsler",
  "route_notify_me": "Varsle meg",
  "route_camera_alt": "Kamera: {location}",
  "route_no_camera_available": "Ingen kamera tilgjengelig",
  "price": "Pris",
  "car": "Bil",
  "passenger": "Passasjer",
  "free": "Gratis",
  "route_amount_kr": "{amount} kr",
  "route_price_unavailable": "Prisinfo ikke tilgjengelig",
  "route_punctuality": "Punktlighet",
  "route_related_docks": "Relaterte kaier",
  "route_dock_label": "{name} fergekai",
  "dock_unknown": "Ukjent kai",
  "dock_realtime_unavailable_no_cache": "Sanntid midlertidig utilgjengelig – ingen lagrede avganger funnet",
  "dock_fetch_departures_failed": "Kunne ikke hente avganger",
  "dock_seo_title": "{dock} fergekai – Avganger og kamera | Ruty",
  "dock_seo_description": "Live avgangstider, kø og webkamera for {dock} fergekai.",
  "dock_seohead_description": "Finn parkering, se avganger og kart for {dock}. Sanntidsinformasjon og værvarsel for fergekaien.",
  "dock_faq_parking_q": "Er det parkering ved {dock} fergekai?",
  "dock_faq_parking_a": "De fleste fergekaier i Norge har gratis parkering i nærområdet. Ved {dock} anbefales det å komme tidlig i høysesong for å sikre plass.",
  "dock_faq_arrival_q": "Når bør jeg møte opp ved {dock}?",
  "dock_faq_arrival_a": "Vi anbefaler å møte opp minst 10–15 minutter før avgang. I høysesong og helger bør du være enda tidligere for å sikre plass.",
  "dock_faq_camera_q": "Finnes det kamera ved {dock}?",
  "dock_faq_camera_a": "Ruty viser tilgjengelige kameraer fra Statens vegvesen nær {dock}. Trykk «Kamera»-knappen på denne siden for å se live-bilder.",
  "dock_type_label": "Fergekai",
  "dock_trust_caution": "Noe av informasjonen er usikker akkurat nå",
  "dock_trust_stale_30min": "Sanntidsdata er over 30 minutter gammel",
  "dock_trust_realtime_delayed": "Sanntidsdata kan være forsinket",
  "dock_map_aria": "Kartplassering for {dock}",
  "dock_map_alt": "Kart over {dock}",
  "dock_map_fallback": "Vis {dock} på kart",
  "dock_map_open_osm": "Åpne i OpenStreetMap",
  "dock_map_caption": "{dock} ligger på koordinatene {coords}. Bruk OpenStreetMap-lenken for kart og veibeskrivelse.",
  "route_map_caption": "Kart over fergesambandet {from}–{to}. Markørene viser ferjekaiene, og fergefiguren viser live eller estimert posisjon på overfarten.",
  "route_map_aria": "Kart over fergesambandet {from}–{to}",
  "dock_map_unavailable": "Kartplassering er ikke tilgjengelig.",
  "dock_no_coords": "Kunne ikke finne koordinater for denne kaien.",
  "dock_search_ferry_link": "Søk etter fergekai →",
  "dock_tab_departures": "Avganger",
  "dock_set_as_favorite": "Sett som favoritt",
  "dock_faq_parking_short_q": "Er det parkering ved {dock}?",
  "dock_faq_parking_short_a": "De fleste fergekaier har gratis parkering rett ved kaien. I høysesong anbefales det å komme tidlig da plassene fylles raskt.",
  "dock_faq_arrival_short_q": "Når bør jeg møte opp?",
  "dock_faq_arrival_short_a": "Møt opp 10–15 minutter før avgang. I helger og ferier, kom enda tidligere.",
  "dock_faq_camera_short_q": "Finnes det kamera ved {dock}?",
  "dock_faq_camera_short_a": "Trykk «Kamera»-knappen over for å se live-bilder fra Statens vegvesen.",
  "dock_practical_info": "Praktisk info om {dock}",
  "dock_facilities": "Fasiliteter",
  "dock_facility_wc": "WC",
  "dock_facility_kafe": "Kafe",
  "dock_facility_billettautomat": "Billettautomat",
  "dock_facility_kiosk": "Kiosk",
  "dock_facility_ventehall": "Ventehall",
  "dock_facility_venteskur": "Venteskur",
  "dock_facility_ladestasjoner": "Ladestasjoner",
  "dock_facility_turistinformasjon": "Turistinformasjon",
  "dock_parking": "Parkering",
  "dock_arrival": "Oppmøte",
  "dock_related_routes": "Relaterte samband",
  // Search page — Batch B3
  "search_page_title": "Søk etter fergesamband",
  "search_page_description": "Søk etter fergesamband i Norge og legg til favoritter på hjemskjermen.",
  "search_seo_title": "Søk – Ruty",
  "search_seo_description": "Søk etter fergesamband og legg til favoritter.",
  "search_input_placeholder": "Søk etter samband eller sted",
  "search_no_results_title": "Ingen samband funnet.",
  "search_no_results_hint": "Prøv et annet sted eller navn.",
  "search_popular_heading": "Populære samband",
  "search_free_limit_title_zero": "Du har lagret {count} av {limit} samband",
  "search_free_limit_title_one": "Du har lagret {count} av {limit} samband",
  "search_free_limit_title_two": "Du har lagret {count} av {limit} samband",
  "search_free_limit_title_few": "Du har lagret {count} av {limit} samband",
  "search_free_limit_title_many": "Du har lagret {count} av {limit} samband",
  "search_free_limit_title_other": "Du har lagret {count} av {limit} samband",
  "search_free_limit_desc": "Gratis-planen tillater maks {limit} favoritter. Oppgrader til Pro for ubegrenset antall.",
  "search_upgrade_cta": "Oppgrader til Pro",
  "search_route_aria": "Gå til {from} til {to}",
  "search_add_favorite_aria": "Legg til {from} til {to} som favoritt",
  "search_remove_favorite_aria": "Fjern {from} til {to} fra favoritter",
  "alerts_seo_title": "Varsler – Ruty",
  "alerts_seo_description": "Administrer dine fergevarsler. Få beskjed før neste avgang.",
  "alerts_toast_update_failed": "Kunne ikke oppdatere varsel",
  "alerts_toast_deleted": "Varsel slettet",
  "alerts_toast_delete_failed": "Kunne ikke slette varsel",
  "alerts_toast_master_enabled": "Alle varsler er aktivert",
  "alerts_toast_master_paused": "Alle varsler er satt på pause",
  "alerts_upsell_title": "Varsler er en del av Ruty Pro",
  "alerts_upsell_description": "Få push-varsler før hver avgang, smart sensitivitet og avansert oppsett. Inkludert i Pro – 7 dager gratis.",
  "alerts_upsell_cta": "Start gratis prøveperiode",
  "alerts_auth_gate_title": "Logg inn for å styre varsler",
  "alerts_auth_gate_description": "Med en konto kan du aktivere push-varsler og administrere påminnelser før avgang.",
  "alerts_auth_gate_cta": "Logg inn",
  "alerts_auth_gate_secondary": "Gå til Mine ferger",
  "alerts_master_active": "Varsler er aktive",
  "alerts_master_paused": "Alle varsler er pauset",
  "alerts_master_pause_aria": "Pause alle varsler",
  "alerts_master_activate_aria": "Aktiver alle varsler",
  "alerts_empty_title": "Du har ingen aktive varsler",
  "alerts_empty_hint": "Gå til et samband og opprett et varsel for å bli minnet på neste avgang.",
  "alerts_browse_samband": "Bla i samband",
  "alerts_both_directions": "Begge retninger",
  "alerts_globally_paused": "· globalt pauset",
  "alerts_last_triggered": "· sist trigget {date}",
  "alerts_deactivate_aria": "Deaktiver varsel",
  "alerts_activate_aria": "Aktiver varsel",
  "alerts_delete_aria": "Slett varsel",
  "results_loading_more": "Laster flere avganger…",
  "results_reason_only_route": "Eneste tilgjengelige rute",
  "results_reason_fastest_now": "Raskeste rute akkurat nå",
  "results_reason_fastest_with_margin": "Raskeste rute med god margin",
  "results_reason_safest": "Tryggeste alternativ med god tidsmargin",
  "results_reason_likely_catch": "Nærmeste avgang du sannsynligvis rekker",
  "results_reason_nearest": "Nærmeste tilgjengelige avgang",
  "results_km_driving": "{km} km kjøring",
  "results_tight_warning": "⏱ Lite tidsmargin — vær ved kai i god tid",
  "results_drive_to_dock": "Kjøretid til kai: {time}",
  "results_ferry_leaves": "Ferge går: kl {time}",
  "results_drive_estimated_note": "Kjøretid er estimert — faktisk margin kan avvike",
  "results_margin_wont_make": "⛔ Du rekker sannsynligvis ikke denne avgangen",
  "alerts_configured_active_zero": "{n} varsler er satt opp.",
  "alerts_configured_active_one": "{n} varsel er satt opp.",
  "alerts_configured_active_two": "{n} varsler er satt opp.",
  "alerts_configured_active_few": "{n} varsler er satt opp.",
  "alerts_configured_active_many": "{n} varsler er satt opp.",
  "alerts_configured_active_other": "{n} varsler er satt opp.",
  "alerts_configured_paused_zero": "{n} varsler er bevart, men leveres ikke før du slår på igjen.",
  "alerts_configured_paused_one": "{n} varsel er bevart, men leveres ikke før du slår på igjen.",
  "alerts_configured_paused_two": "{n} varsler er bevart, men leveres ikke før du slår på igjen.",
  "alerts_configured_paused_few": "{n} varsler er bevart, men leveres ikke før du slår på igjen.",
  "alerts_configured_paused_many": "{n} varsler er bevart, men leveres ikke før du slår på igjen.",
  "alerts_configured_paused_other": "{n} varsler er bevart, men leveres ikke før du slår på igjen.",
  "queue_report_window_count_zero": "{n} rapporter siste 45 min",
  "queue_report_window_count_one": "{n} rapport siste 45 min",
  "queue_report_window_count_two": "{n} rapporter siste 45 min",
  "queue_report_window_count_few": "{n} rapporter siste 45 min",
  "queue_report_window_count_many": "{n} rapporter siste 45 min",
  "queue_report_window_count_other": "{n} rapporter siste 45 min",
  "ferry_results_ferry_count_zero": "{n} ferger ({min} min)",
  "ferry_results_ferry_count_one": "{n} ferge ({min} min)",
  "ferry_results_ferry_count_two": "{n} ferger ({min} min)",
  "ferry_results_ferry_count_few": "{n} ferger ({min} min)",
  "ferry_results_ferry_count_many": "{n} ferger ({min} min)",
  "ferry_results_ferry_count_other": "{n} ferger ({min} min)",
  "tripplan_disruption_count_zero": "{n} avvik",
  "tripplan_disruption_count_one": "Avvik",
  "tripplan_disruption_count_two": "{n} avvik",
  "tripplan_disruption_count_few": "{n} avvik",
  "tripplan_disruption_count_many": "{n} avvik",
  "tripplan_disruption_count_other": "{n} avvik",
  "tripplan_more_disruptions_zero": " (+{n} til)",
  "tripplan_more_disruptions_one": " (+{n} til)",
  "tripplan_more_disruptions_two": " (+{n} til)",
  "tripplan_more_disruptions_few": " (+{n} til)",
  "tripplan_more_disruptions_many": " (+{n} til)",
  "tripplan_more_disruptions_other": " (+{n} til)",
  "route_disruption_heading_zero": "Avvik ({n})",
  "route_disruption_heading_one": "Avvik ({n})",
  "route_disruption_heading_two": "Avvik ({n})",
  "route_disruption_heading_few": "Avvik ({n})",
  "route_disruption_heading_many": "Avvik ({n})",
  "route_disruption_heading_other": "Avvik ({n})",
  "dock_disruption_heading_zero": "Avvik ({n})",
  "dock_disruption_heading_one": "Avvik ({n})",
  "dock_disruption_heading_two": "Avvik ({n})",
  "dock_disruption_heading_few": "Avvik ({n})",
  "dock_disruption_heading_many": "Avvik ({n})",
  "dock_disruption_heading_other": "Avvik ({n})",
  "route_alert_active_count_zero": "{n} varsler aktive",
  "route_alert_active_count_one": "{n} varsel aktivt",
  "route_alert_active_count_two": "{n} varsler aktive",
  "route_alert_active_count_few": "{n} varsler aktive",
  "route_alert_active_count_many": "{n} varsler aktive",
  "route_alert_active_count_other": "{n} varsler aktive",
  "route_disruption_30d_count_zero": "{n} avvik siste 30 dager",
  "route_disruption_30d_count_one": "{n} avvik siste 30 dager",
  "route_disruption_30d_count_two": "{n} avvik siste 30 dager",
  "route_disruption_30d_count_few": "{n} avvik siste 30 dager",
  "route_disruption_30d_count_many": "{n} avvik siste 30 dager",
  "route_disruption_30d_count_other": "{n} avvik siste 30 dager",
  "status_error_count_zero": "Ingen feil",
  "status_error_count_one": "{n} feil",
  "status_error_count_two": "{n} feil",
  "status_error_count_few": "{n} feil",
  "status_error_count_many": "{n} feil",
  "status_error_count_other": "{n} feil",
  "monitor_active_disruption_count_zero": "{n} avvik aktive",
  "monitor_active_disruption_count_one": "{n} avvik aktivt",
  "monitor_active_disruption_count_two": "{n} avvik aktive",
  "monitor_active_disruption_count_few": "{n} avvik aktive",
  "monitor_active_disruption_count_many": "{n} avvik aktive",
  "monitor_active_disruption_count_other": "{n} avvik aktive",
  "home_toast_favorite_added_title": "Lagt til",
  "home_toast_favorite_added_desc": "{from} – {to} lagret.",
  "home_toast_pro_limit_title": "Du har nådd grensen for gratis-planen",
  "home_toast_pro_limit_desc": "Oppgrader til Pro for å lagre flere enn {limit} samband.",
  "home_toast_favorite_error_title": "Kunne ikke lagre favoritt",
  "home_toast_favorite_error_desc": "Prøv igjen om litt.",
  "home_toast_shared_ferry_opened": "Åpnet delt ferge",
  "home_outlook_loading": "Henter dagens fergestatus …",
  "home_offline_cached_prefix": "Offline – viser data fra {age}",
  "home_offline_no_cache": "Offline – ingen lagrede data",
  "home_offline_banner": "Du er offline – viser sist kjente data",
  "home_seo_title": "Ruty – Fergeinformasjon Norge",
  "home_seo_description": "Sanntids fergeinformasjon for hele Norge. Finn nærmeste bilferge, se avganger og planlegg overfarten.",
  "ferry_seo_title": "Fergeruter Norge – Live avgangstider | Ruty",
  "ferry_seo_description": "Se live avgangstider for norske fergesamband. Finn nærmeste samband, sjekk status og planlegg fergeturen.",
  "planlegg_seo_title": "Planlegg fergetur – Ruty",
  "planlegg_seo_description": "Planlegg fergeturen din i Norge. Velg fra og til, se avganger og finn beste overfart.",
  "home_status_banner_aria": "Dagens fergestatus",
  "home_status_banner_label": "Ferjenorge i dag · {date}",
  "home_status_banner_label_region": "{region} i dag · {date}",
  "home_status_banner_calm_local": "Ingen kjente avvik i ditt område akkurat nå.",
  "home_status_banner_more_alerts": "+ {n} andre varsler i regionen",
  "home_auth_cta_lead": "Lagre favorittene dine på alle enheter:",
  "home_warm_eyebrow": "Din ferge",
  "home_warm_greeting_morning": "God morgen",
  "home_warm_greeting_afternoon": "God ettermiddag",
  "ferry_region_oslofjorden": "Oslofjorden",
  "ferry_region_vestlandet": "Vestlandet",
  "ferry_region_trondelag_helgeland": "Trøndelag / Helgeland",
  "ferry_region_nord_norge": "Nord-Norge",
  "ferry_region_sorlandet": "Sørlandet",
  "home_finding_position": "Finner posisjon …",
  "home_add_picker_title": "Velg samband eller kai",
  "home_add_picker_cancel": "Avbryt",
  "home_add_picker_kai_added_desc": "{name} er nå en favoritt-kai.",
  "home_add_picker_kai_placeholder": "Søk etter kai (f.eks. Halhjem)",
  "home_add_picker_kai_aria": "Søk etter fergekai",
  "home_add_picker_filter_placeholder": "…eller filtrer populære samband",
  "home_add_picker_no_results": "Ingen treff",
  "home_add_picker_saved": "Lagret",
  "home_add_picker_add": "+ Legg til",
  "home_quicklinks_aria": "Hurtiglenker",
  "home_shortcuts_aria": "Snarveier",
  "home_push_aria": "Push-varsler",
  "push_sensitivity_critical": "Kun kritisk",
  "push_sensitivity_recommended": "Anbefalt",
  "push_sensitivity_more": "Mer varsler",
  "push_gate_quiet_hours": "Stille timer aktive (22–07)",
  "push_gate_cooldown": "Allerede varslet for denne kaien nylig",
  "push_gate_daily_cap": "Maks antall varsler i dag nådd",
  "push_gate_no_urgency": "Ingen haste-avganger akkurat nå",
  "push_gate_snoozed": "Varsler er utsatt",
  "push_gate_dock_disabled": "Varsler for denne kaien er slått av",
  "push_gate_not_enabled": "Varsler er ikke aktivert",
  "push_gate_under_threshold": "Ikke relevant nok basert på innstillinger",
  "push_preview_score_line": "score {score} / terskel {threshold}",
  "push_timing_label": "Varslingstidspunkt",
  "push_sending": "Sender...",
  "push_test_result_sent": "✅ Testvarsel sendt!",
  "push_test_result_no_subscription": "⚠️ Ingen aktiv subscription",
  "push_test_result_daily_cap": "⚠️ Daglig maks nådd",
  "push_test_result_error": "❌ Feil ved sending",
  "push_off_title": "Få varsel før neste avgang",
  "push_off_subtitle_dock": "Slå på push-varsler for {dock} – aldri miss ferga.",
  "push_off_subtitle_generic": "Slå på push-varsler så du aldri går glipp av en avgang.",
  "push_setup_nudge": "Velg et samband for å få påminnelser",
  "push_unsupported_title": "Push-varsler støttes ikke i denne nettleseren",
  "push_unsupported_body": "På iPhone må du legge Ruty til på hjemskjermen først (Del → Legg til på Hjemskjerm). Da kan du motta varsler før neste avgang.",
  "push_denied_title": "Varsler er blokkert i nettleseren",
  "push_denied_body": "For å motta varsler før avgang må du tillate notifikasjoner for ruty.no i nettleserens innstillinger, og deretter laste siden på nytt.",
  "push_on_celebrating": "Varsler er aktivert ✓",
  "push_on_dock": "Varsler aktive for {dock}",
  "push_on_generic": "Varsler er aktive",
  "push_on_subtitle_on": "Varsler er på.",
  "push_on_subtitle_nudge": "Velg et samband for å motta påminnelser.",
  "push_on_subtitle_default": "Du får beskjed før neste avgang. Du kan slå av når som helst.",
  "push_disable_short": "Slå av",
  "push_activating": "Aktiverer …",
  "myferries_pending_offline": "Venter på nett",
  "myferries_service_alert_aria": "Driftsavvik",
  "myferries_remove_aria": "Fjern {name}",
  "myferries_next_departures_tomorrow": "Neste avganger i morgen",
  "myferries_schedule_error": "Kunne ikke hente avgangstider akkurat nå",
  "myferries_no_departures": "Ingen planlagte avganger funnet",
  "myferries_hide_extra": "Skjul ekstra avganger",
  "myferries_manage_alert": "Administrer varsel",
  "myferries_alert_active": "Varsel aktivt",
  "myferries_toast_remove_failed_title": "Kunne ikke fjerne favoritt",
  "myferries_toast_remove_failed_desc": "Prøv igjen om litt.",
  "myferries_upsell_title": "Du har lagret {saved} av {limit} samband",
  "myferries_upsell_description": "Oppgrader til Pro for å lagre flere samband, smarte varsler og avanserte verktøy.",
  "upgrade_trial_label": "7 dagers gratis prøveperiode",
  "upgrade_feature_unlimited_favorites": "Ubegrenset antall favorittsamband (utover 2)",
  "upgrade_feature_smart_push": "Smarte push-varsler og avansert varsler-oppsett",
  "upgrade_feature_calculator": "Avansert «Rekker du ferga?»-kalkulator",
  "upgrade_feature_priority": "Prioritert tilgang til nye funksjoner",
  "upgrade_welcome_toast": "Velkommen til Ruty Pro!",
  "upgrade_checkout_error": "Kunne ikke åpne kassen. Prøv igjen.",
  "upgrade_portal_error": "Kunne ikke åpne abonnementsportalen.",
  "upgrade_portal_no_subscription": "Ingen aktivt abonnement",
  "upgrade_seo_title": "Oppgrader til Ruty Pro – 7 dagers gratis prøveperiode",
  "upgrade_seo_description": "Få ubegrensede favoritter, smarte varsler og avansert «Rekker du ferga?» med Ruty Pro. 39 kr/mnd, 7 dagers gratis prøveperiode.",
  "upgrade_h1": "Få mest mulig ut av fergehverdagen",
  "upgrade_subtitle": "Smarte varsler, ubegrensede favoritter og avanserte verktøy.",
  "upgrade_syncing": "Synker abonnement…",
  "upgrade_sync_timeout_title": "Abonnementet er ikke registrert ennå",
  "upgrade_sync_timeout_body": "Betalingen kan være under behandling. Dette tar vanligvis bare noen sekunder.",
  "upgrade_retry_sync": "Sjekk på nytt",
  "upgrade_loading": "Laster…",
  "upgrade_current_status": "Du har Ruty Pro",
  "upgrade_manage": "Administrer abonnement",
  "upgrade_cta_start_trial": "Start gratis prøveperiode",
  "upgrade_cta_login_first": "Logg inn for å starte",
  "upgrade_disclaimer": "Ruty Pro er et digitalt abonnement. Krever betalingsmetode. Du belastes ikke før prøveperioden er over. Abonnementet fornyes automatisk til valgt pris (måned/år) til du sier opp via kundeportalen; tilgangen varer ut inneværende periode.",
  "upgrade_terms_sentence": "Ved å starte prøveperioden godtar du våre {terms} og {privacy}. Betaling håndteres av Paddle.com (Merchant of Record).",
  "upgrade_terms_link_terms": "vilkår",
  "upgrade_terms_link_privacy": "personvernregler",
  "upgrade_billing_group_label": "Velg faktureringsperiode",
  "upgrade_billing_monthly": "Månedlig",
  "upgrade_billing_annual": "Årlig",
  "upgrade_price_monthly": "39 kr / mnd",
  "upgrade_price_annual": "349 kr / år",
  "upgrade_price_missing_error": "Pris-ID mangler. Sett VITE_PADDLE_PRICE_ID_MONTHLY / ANNUAL (eller CODE_PRICE_IDS).",
  "upgrade_sandbox_only_error": "Betaling er kun tilgjengelig i sandbox under denne utviklingsfasen.",
  "guide_step_badge_1": "Steg 1",
  "guide_step_badge_2": "Steg 2",
  "guide_step_badge_3": "Steg 3",
  "auth_zod_email_invalid": "Ugyldig e-postadresse",
  "auth_zod_password_min": "Passordet må være minst 6 tegn",
  "auth_zod_name_min": "Navn må være minst 2 tegn",
  "auth_zod_password_mismatch": "Passordene matcher ikke",
  "auth_google_error": "Kunne ikke logge inn med Google",
  "auth_invalid_credentials": "Feil e-post eller passord",
  "auth_email_already_registered": "Denne e-postadressen er allerede registrert",
  "auth_seo_title": "Logg inn | Ruty",
  "auth_seo_description": "Logg inn for å lagre favoritter og se historikk",
  "auth_seo_description_alerts": "Logg inn for å aktivere og administrere fergevarsler",
  "auth_welcome_title": "Velkommen",
  "auth_welcome_description": "Logg inn eller opprett en bruker for å lagre favoritter",
  "auth_welcome_description_alerts": "Logg inn eller opprett en bruker for å styre varsler",
  "auth_continue_with_google": "Fortsett med Google",
  "auth_divider_or": "eller",
  "auth_tab_login": "Logg inn",
  "auth_tab_signup": "Registrer",
  "auth_email_label": "E-post",
  "auth_email_placeholder": "din@epost.no",
  "auth_password_label": "Passord",
  "auth_login_submit_loading": "Logger inn...",
  "auth_login_submit": "Logg inn",
  "auth_back_home": "Tilbake til hjem",
  "auth_fullname_label": "Fullt navn",
  "auth_fullname_placeholder": "Ola Nordmann",
  "auth_signup_password_placeholder": "Minst 6 tegn",
  "auth_confirm_password_label": "Bekreft passord",
  "auth_signup_submit_loading": "Oppretter bruker...",
  "auth_signup_submit": "Opprett bruker",
  "mineferger_seo_title": "Mine ferger – Ruty",
  "mineferger_seo_description": "Dine lagrede samband og varsler på ett sted.",
  "mineferger_h1": "Mine ferger",
  "mineferger_aria_favorites": "Lagrede favoritter",
  "mineferger_empty_title": "Du har ingen lagrede samband ennå",
  "mineferger_empty_desc": "Åpne et samband og trykk «Favoritt» — da samles de her.",
  "mineferger_browse_routes": "Bla i samband",
  "mineferger_aria_alerts": "Aktive varsler",
  "mineferger_alerts_heading": "Aktive varsler",
  "mineferger_globally_paused": "globalt pauset",
  "mineferger_manage": "Administrer",
  "mineferger_loading_alerts": "Henter varsler …",
  "mineferger_no_alerts": "Ingen aktive varsler. Opprett varsel fra et samband.",
  "mineferger_paused_suffix": "· pauset",
  "mineferger_onboarding_completed": "Alt klart! Du får nå varsler om dine favoritt-ferger.",
  "mineferger_onboarding_close_aria": "Lukk",
  "mineferger_onboarding_close_guide_aria": "Lukk veiledning",
  "mineferger_onboarding_title": "Kom i gang ({done}/{total})",
  "mineferger_onboarding_subtitle": "Tre raske steg for å få mest ut av Mine ferger.",
  "mineferger_onboarding_step1_title": "Lagre ditt første samband",
  "mineferger_onboarding_step1_desc": "Velg et samband du bruker ofte og trykk Favoritt.",
  "mineferger_onboarding_step1_cta": "Bla i samband",
  "mineferger_onboarding_step2_title": "Aktiver push-varsler",
  "mineferger_onboarding_step2_desc": "Få beskjed før avgang og ved avvik.",
  "mineferger_onboarding_step2_cta": "Gå til aktivering",
  "mineferger_onboarding_step3_title": "Sett opp varsler",
  "mineferger_onboarding_step3_desc": "Velg lead-time og hvilke samband som varsler deg.",
  "mineferger_onboarding_step3_cta": "Administrer varsler",
  "mineferger_onboarding_step_done": "Fullført",
  "commuter_toast_select_departure_days": "Velg avgang og dager",
  "commuter_toast_saved_title": "✓ Pendler-varsel aktivert",
  "commuter_toast_max_title": "Maks 3 profiler",
  "commuter_toast_max_desc": "Slett en eksisterende profil først.",
  "commuter_toast_save_error_title": "Feil",
  "commuter_toast_save_error_desc": "Kunne ikke lagre pendlerprofil.",
  "commuter_toast_deleted_title": "Slettet",
  "commuter_toast_deleted_desc": "Pendlerprofilen er fjernet.",
  "commuter_toast_delete_error_desc": "Kunne ikke slette.",
  "commuter_mode_label": "Pendler-modus",
  "commuter_select_departure_label": "Velg fast avgang",
  "commuter_select_departure_placeholder": "Velg avgangstid",
  "commuter_days_label": "Dager",
  "commuter_notify_label": "Varsel",
  "commuter_activate_button": "Aktiver pendler-varsel",
  "commuter_limit_hint": "Maks 3 pendlerprofiler. Slett en for å legge til ny.",
  "commuter_day_mon": "Man",
  "commuter_day_tue": "Tir",
  "commuter_day_wed": "Ons",
  "commuter_day_thu": "Tor",
  "commuter_day_fri": "Fre",
  "commuter_day_sat": "Lør",
  "commuter_day_sun": "Søn",
  "ferry_search_dest_title": "Skriv inn destinasjon",
  "ferry_search_dest_desc": "Velg hvor du ønsker å reise",
  "ferry_search_origin_title": "Velg avreisested",
  "ferry_search_origin_desc": "Bruk Min posisjon eller skriv inn avreisested",
  "ferry_search_no_routes": "Ingen bilfergeruter funnet for denne strekningen",
  "ferry_search_realtime_unavailable": "Sanntid midlertidig utilgjengelig. Prøv igjen om litt.",
  "ferry_search_failed": "Kunne ikke søke etter fergeruter",
  "geo_unsupported_title": "Geolokasjon støttes ikke",
  "geo_unsupported_desc": "Nettleseren din støtter ikke posisjonering",
  "weather_fetch_failed": "Kunne ikke hente vær",
  "weather_dir_n": "N",
  "weather_dir_ne": "NØ",
  "weather_dir_e": "Ø",
  "weather_dir_se": "SØ",
  "weather_dir_s": "S",
  "weather_dir_sw": "SV",
  "weather_dir_w": "V",
  "weather_dir_nw": "NV",
  "route_alerts_fetch_failed": "Kunne ikke hente varsler",
  "offline_banner": "Du er offline – viser siste lagrede data",
  "day_outlook_loading": "Laster oversikt...",
  "loading_departures_aria": "Laster avganger",
  "nav_search": "Søk",
  "not_found_ferry_aria": "Gå til ferge-oversikt",
  "not_found_ferry_link": "Ferge",
  "not_found_search_label": "Søk etter fergesamband eller kai",
  "not_found_search_placeholder": "F.eks. Moss–Horten",
  "not_found_popular_heading": "Populære fergesamband",
  "oauth_no_redirect": "Ingen omdirigering fra autorisasjons-serveren.",
  "oauth_load_failed": "Kunne ikke laste forespørselen",
  "oauth_loading": "Laster…",
  "oauth_external_app": "En ekstern app",
  "oauth_connect_title": "Koble {name} til Ruty",
  "oauth_connect_desc": "{name} vil kunne bruke Rutys verktøy som deg mens du er logget inn.",
  "oauth_grants_intro": "Dette gir tilgang til:",
  "oauth_grant_profile": "Din profil og e-post",
  "oauth_grant_tools": "Aktivering av Rutys aktiverte verktøy på dine vegne (favoritter, kø-rapporter)",
  "oauth_redirect_label": "Omdirigering:",
  "hero_nearest_quay": "Nærmeste kai",
  "hero_plan_route": "Planlegg rute",
  "hero_searching_area": "Søker i nærområdet…",
  "hero_finding_position": "Finner posisjon…",
  "hero_no_ferries_nearby": "Fant ingen bilfergekaier i nærheten (innen 50 km).",
  "hero_show_anyway": "Vis nærmeste likevel",
  "hero_showing_cached": "Viser lagrede avganger",
  "driving_mode_active_toast": "🚗 På vei-modus aktiv",
  "driving_mode_cta": "Jeg er på vei",
  "driving_mode_active_label": "På vei – aktiv ({n})",
  "search_history_title": "Dine tidligere søk",
  "search_history_your_position": "Din posisjon",
  "search_history_clear_all": "Tøm alt",
  "ferry_search_again": "Søk igjen",
  "ferry_next_fetch_failed": "Kunne ikke hente neste avgang",
  "ferry_no_upcoming": "Ingen kommende avgang",
  "ferry_monitor_favorite_changes": "⚠️ Din favoritt-ferge har endringer",
  "ferry_no_departure_30min": "Ingen avgang de neste 30 min",
  "ferry_no_departures": "Ingen avganger",
  "driving_mode_activate_failed_title": "Kunne ikke aktivere",
  "driving_mode_activate_failed_desc": "Prøv igjen om litt.",
  "driving_mode_end": "Avslutt",
  "driving_mode_activating": "Aktiverer...",
  "route_short": "Rute",
  "ferry_no_upcoming_plural": "Ingen kommende avganger",
  "ferry_monitor_dock_not_found": "Fant ikke favorittkaia akkurat nå",
  "oauth_missing_id": "Mangler authorization_id",
  "oauth_policy_note": "Dette overstyrer ikke Rutys tilgangskontroll eller backend-policyer.",
  "oauth_deny": "Avslå",
  "oauth_approve": "Godkjenn",
  "oauth_approving": "Godkjenner…",
  "route_faq_duration_q": "Hvor lang tid tar fergen fra {from} til {to}?",
  "route_faq_duration_a": "Overfartstiden varierer per samband. Sjekk avgangstidene på denne siden for å beregne reisetid.",
  "route_faq_cost_q": "Hva koster fergen {from}–{to}?",
  "route_faq_cost_a": "De fleste bilferger i Norge betales med AutoPASS-brikke eller kort direkte om bord.",
  "route_faq_queue_q": "Er det kø på {from}–{to}?",
  "route_faq_queue_a": "Sjekk sanntids køstatus øverst på denne siden.",
  "route_faq_car_q": "Kan jeg ta med bil på fergen {from}–{to}?",
  "route_faq_car_a": "Ja, dette er et bilfergesamband.",
  "route_faq_ticket_q": "Må jeg bestille billett for {from}–{to}?",
  "route_faq_ticket_a": "De fleste bilferger i Norge opererer uten forhåndsbestilling – du kjører rett om bord. I høysesong anbefales det å komme tidlig.",
  "route_faq_freq_q": "Hvor ofte går fergen fra {from} til {to}?",
  "route_faq_freq_a": "Avgangene varierer etter sesong og ukedag. Se sanntidsoversikten over for oppdaterte tider.",
  "walking_onto": " inn på {street}",
  "walking_depart": "Start å gå",
  "walking_depart_street": "Gå {street}",
  "walking_arrive": "Du er fremme",
  "walking_turn_left": "Sving til venstre",
  "walking_turn_right": "Sving til høyre",
  "walking_slight_left": "Hold til venstre",
  "walking_slight_right": "Hold til høyre",
  "walking_sharp_left": "Skarp sving til venstre",
  "walking_sharp_right": "Skarp sving til høyre",
  "walking_uturn": "Snu",
  "walking_continue": "Fortsett",
  "walking_continue_straight": "Fortsett rett frem",
  "walking_continue_street": "Fortsett på {street}",
  "walking_merge": "Flett inn",
  "walking_fork_left": "Hold til venstre i veikrysset",
  "walking_fork_right": "Hold til høyre i veikrysset",
  "walking_end_left": "Sving til venstre ved enden av veien",
  "walking_end_right": "Sving til høyre ved enden av veien",
  "walking_roundabout": "Ta rundkjøringen",
  "walking_exit_roundabout": "Forlat rundkjøringen",
  "tripplan_removed_favorite": "Fjernet fra favoritter",
  "tripplan_added_favorite": "Lagt til i favoritter",
  "tripplan_on_time": "På tid",
  "map_loading": "Laster kart...",
  "map_enable_aria": "Aktiver kart for å panorere og zoome",
  "ferry_list_samband": "Samband",
  "ferry_list_search_placeholder": "Søk etter samband...",
  "status_push_metrics_24h": "Push-varsler (24t)",
  "index_plan_failed_title": "Sanntid midlertidig utilgjengelig",
  "index_plan_failed_desc": "Kunne ikke planlegge reisen akkurat nå. Prøv igjen om litt.",
  "contact_schema_description": "Ta kontakt med Ruty for spørsmål, tilbakemeldinger eller teknisk støtte.",
  "ferry_popular_empty_hint": "🚗 Søk etter en ferge for å se neste avganger her.",
  "ferry_swap_from_to_aria": "Bytt fra og til",
  "ferry_weather_severe_wind": "🔴 Svært sterk vind – mulige forsinkelser",
  "pwa_add_to_homescreen": "Legg til på hjemskjerm",
  "edge_rate_limited": "For mange forespørsler. Vent litt og prøv igjen.",
  "edge_timeout": "Forespørselen tok for lang tid. Prøv igjen.",
  "favorites_fetch_failed": "Kunne ikke hente favoritter",
  "route_faq_title": "Ofte stilte spørsmål",
  "ferry_list_sort_alpha": "Alfabetisk",
  "ferry_list_sort_score": "Beste score",
  "map_follow_me": "Følg meg",
  "map_focus_drive": "Strekning til kai",
  "map_focus_samband": "Samband",
  "nearby_switched_title": "Nærmeste samband oppdatert",
  "nearby_switched_desc": "Viser nå {name}",
  "contact_schema_name": "Kontakt Ruty",
  "status_push_metrics_error": "Kunne ikke hente push-metrics",
  "feedback_general_destination": "Generell tilbakemelding",
  "map_click_to_use": "Klikk for å bruke kartet",
  "map_lock": "Lås kartet",
  "map_show_full_route": "Vis hele reisen",
  "ferry_weather_strong_wind": "⚠️ Sterk vind – sjekk trafikkinfo",
  "ferry_weather_title": "Værvarsel",
  "pwa_quick_access": "Rask tilgang til ferjeavganger",
  "pwa_install": "Installer",
  "ferry_swap_direction_title": "Bytt retning",
  "ferry_fetching_next_departure": "Henter neste avgang …",
  "ferry_departure_unavailable": "Avgang ikke tilgjengelig",
  "next_departure": "Neste avgang",
  "favorite_label": "Favoritt",
  "ferry_share_title": "Ferge: {name}",
  "ferry_share_text": "Se avganger fra {name} på Ruty",
  "ferry_calendar_title": "Ferge: {from} → {to}",
  "ferry_calendar_location": "{from} fergekai",
  "ferry_calendar_description": "Ferjeavgang fra {from} til {to}.\nSe avganger: https://ruty.no/ferge",
  "not_found_seo_title": "Siden finnes ikke – Ruty",
  "logout": "Logg ut",
  "sw_update_available_title": "Ny versjon tilgjengelig",
  "sw_update_available_body": "Oppdater for å få siste endringer.",
  "sw_update_action": "Oppdater",
  "home_your_samband": "Ditt samband",
  "home_change_samband": "Bytt",
  "home_flip_direction": "Snu retning",
  "departure_at": "Går kl.",
  "departure_delayed": "{min} min forsinket",
  "departure_cancelled": "Innstilt",
  "departure_cached": "Lagret – kan være utdatert",
  "realtime": "Sanntid",
  "scheduled_time": "Rutetid",
  "home_later": "Senere",
  "home_leaves_now": "Går nå",
  "home_nearest_samband": "Nærmeste samband",
  "catch_safer_option": "Tryggere: {time} – kjør senest {leave}",
};
